const countriesData = [
  {
    country: "Afghanistan",
    states: [
      { state: "Badakhshan", cities: ["Fayzabad", "Khandud", "Khash", "Jurm", "Wakhan"] },
      { state: "Badghis", cities: ["Qala i Naw", "Balamorghab", "Jawand", "Ab Kamari", "Ghormach"] },
      { state: "Baghlan", cities: ["Pul-e-Khumri", "Nahrin", "Baghlan", "Dushi", "Khost"] },
      { state: "Balkh", cities: ["Mazar-i-Sharif", "Balkh", "Hairatan", "Kholm", "Dawlatabad"] },
      { state: "Bamyan", cities: ["Bamyan", "Panjab", "Yakawlang", "Waras", "Shibar"] },
      { state: "Daykundi", cities: ["Nili", "Shahristan", "Sangi Takht", "Kajran", "Kiti"] },
      { state: "Farah", cities: ["Farah", "Anar Dara", "Bakwa", "Bala Buluk", "Gulistan"] },
      { state: "Faryab", cities: ["Maymana", "Andkhoy", "Qaramqul", "Almar", "Dawlatabad"] },
      { state: "Ghazni", cities: ["Ghazni", "Qarabagh", "Andar", "Waghaz", "Nawur"] },
      { state: "Ghor", cities: ["Firozkoh", "Shahrak", "Taywara", "Tulak", "Chaghcharan"] },
      { state: "Helmand", cities: ["Lashkar Gah", "Greshk", "Sangin", "Musa Qala", "Nawzad"] },
      { state: "Herat", cities: ["Herat", "Shindand", "Karukh", "Guzara", "Kohsan"] },
      { state: "Jowzjan", cities: ["Sheberghan", "Aqcha", "Fayzabad", "Dar zab", "Qush Tepa"] },
      { state: "Kabul", cities: ["Kabul", "Paghman", "Chahar Asyab", "Bagrami", "Deh Sabz"] },
      { state: "Kandahar", cities: ["Kandahar", "Arghandab", "Daman", "Panjwayi", "Spin Boldak"] },
      { state: "Kapisa", cities: ["Mahmud Raqi", "Nijrab", "Tagab", "Koh Band", "Alasay"] },
      { state: "Khost", cities: ["Khost", "Tani", "Mandozai", "Gurbuz", "Nadir Shah Kot"] },
      { state: "Kunar", cities: ["Asadabad", "Narang", "Sawkay", "Chapa Dara", "Asmar"] },
      { state: "Kunduz", cities: ["Kunduz", "Qala-i-Zal", "Imam Sahib", "Khanabad", "Dasht-i-Archi"] },
      { state: "Laghman", cities: ["Mihtarlam", "Qarghayi", "Alingar", "Alishang", "Dawlat Shah"] },
      { state: "Logar", cities: ["Pul-e-Alam", "Baraki Barak", "Mohammad Agha", "Kharwar", "Charkh"] },
      { state: "Nangarhar", cities: ["Jalalabad", "Behsud", "Surkh Rod", "Chaparhar", "Kama"] },
      { state: "Nimruz", cities: ["Zaranj", "Chakhansur", "Kang", "Chahar Burjak", "Khash Rod"] },
      { state: "Nuristan", cities: ["Parun", "Kamdesh", "Barg-i Matal", "Waygal", "Mandol"] },
      { state: "Paktia", cities: ["Gardez", "Sayed Karam", "Zadran", "Ahmadabad", "Zurmat"] },
      { state: "Paktika", cities: ["Sharan", "Urgun", "Surobi", "Omna", "Gayan"] },
      { state: "Panjshir", cities: ["Bazarak", "Rokha", "Dara", "Anaba", "Shotul"] },
      { state: "Parwan", cities: ["Charikar", "Jabal Saraj", "Bagram", "Shinwari", "Siyagird"] },
      { state: "Samangan", cities: ["Aybak", "Khuram Sarbagh", "Hazrat Sultan", "Ruyi Du Ab", "Feroz Nakhchir"] },
      { state: "Sar-e Pol", cities: ["Sar-e Pol", "Sayyad", "Kohistanat", "Sangcharak", "Balkhab"] },
      { state: "Takhar", cities: ["Taloqan", "Farkhar", "Chal", "Yang Qala", "Ishkamish"] },
      { state: "Urozgan", cities: ["Tarinkot", "Chora", "Deh Rahwod", "Khas Urozgan", "Gizab"] },
      { state: "Wardak", cities: ["Maidan Shar", "Nirkh", "Saydabad", "Jalrez", "Chak"] },
      { state: "Zabul", cities: ["Qalat", "Tarnak Wa Jaldak", "Shinkay", "Mizan", "Shamulzayi"] },
    ],
  },
  {
    country: "Albania",
    states: [
      { state: "Berat", cities: ["Berat", "Kuçovë", "Poliçan", "Skrapar", "Ura Vajgurore"] },
      { state: "Dibër", cities: ["Peshkopi", "Bulqizë", "Klos", "Mat", "Burrel"] },
      { state: "Durrës", cities: ["Durrës", "Shijak", "Krujë", "Fushë-Krujë", "Manëz"] },
      { state: "Elbasan", cities: ["Elbasan", "Cërrik", "Peqin", "Gramsh", "Librazhd"] },
      { state: "Fier", cities: ["Fier", "Patos", "Ballsh", "Roskovec", "Lushnjë"] },
      { state: "Gjirokastër", cities: ["Gjirokastër", "Përmet", "Tepelenë", "Memaliaj", "Libohovë"] },
      { state: "Korçë", cities: ["Korçë", "Pogradec", "Maliq", "Bilisht", "Ersekë"] },
      { state: "Kukës", cities: ["Kukës", "Bajram Curri", "Krumë", "Fierzë", "Shishtavec"] },
      { state: "Lezhë", cities: ["Lezhë", "Laç", "Mamurras", "Kurbin", "Rreshen"] },
      { state: "Shkodër", cities: ["Shkodër", "Vau i Dejës", "Pukë", "Fushë-Arrëz", "Koplik"] },
      { state: "Tiranë", cities: ["Tiranë", "Kamëz", "Vorë", "Kavajë", "Rrogozhinë"] },
      { state: "Vlorë", cities: ["Vlorë", "Sarandë", "Himara", "Delvinë", "Orikum"] },
    ],
  },
  {
    country: "Algeria",
    states: [
      { state: "Adrar", cities: ["Adrar", "Aoulef", "Reggane", "Timimoun", "Bordj Badji Mokhtar"] },
      { state: "Chlef", cities: ["Chlef", "El Karimia", "Tenes", "Ech Cheliff", "Oued Fodda"] },
      { state: "Laghouat", cities: ["Laghouat", "Aflou", "Gueltat Sidi Saad", "Ksar El Hirane", "Sidi Makhlouf"] },
      { state: "Oum El Bouaghi", cities: ["Oum El Bouaghi", "Ain Beida", "Ain M'lila", "Meskiana", "Sigus"] },
      { state: "Batna", cities: ["Batna", "Barika", "Merouana", "Arris", "Tazoult"] },
      { state: "Béjaïa", cities: ["Béjaïa", "Akbou", "Tazmalt", "Kherrata", "Sidi Aich"] },
      { state: "Biskra", cities: ["Biskra", "Tolga", "Sidi Khaled", "Ouled Djellal", "Sidi Okba"] },
      { state: "Béchar", cities: ["Béchar", "Abadla", "Kenadsa", "Taghit", "Béni Ounif"] },
      { state: "Blida", cities: ["Blida", "Boufarik", "Bougara", "Ouled Yaïch", "Larbaa"] },
      { state: "Bouïra", cities: ["Bouïra", "Sour El Ghozlane", "Kadiria", "Ain Bessem", "Lakhdaria"] },
      { state: "Tamanrasset", cities: ["Tamanrasset", "In Salah", "In Amguel", "Tazrouk", "Abalessa"] },
      { state: "Tébessa", cities: ["Tébessa", "Bir El Ater", "Cheria", "Ouenza", "El Ogla"] },
      { state: "Tlemcen", cities: ["Tlemcen", "Maghnia", "Ghazaouet", "Nedroma", "Sebdou"] },
      { state: "Tiaret", cities: ["Tiaret", "Frenda", "Sougueur", "Ksar Chellala", "Mahdia"] },
      { state: "Tizi Ouzou", cities: ["Tizi Ouzou", "Azazga", "Tigzirt", "Boghni", "Draâ Ben Khedda"] },
      { state: "Algiers", cities: ["Algiers", "Bab Ezzouar", "Bordj El Kiffan", "Dar El Beïda", "El Harrach"] },
      { state: "Djelfa", cities: ["Djelfa", "Ain Oussera", "Messaad", "Hassi Bahbah", "El Idrissia"] },
      { state: "Jijel", cities: ["Jijel", "El Aouana", "Taher", "Chekfa", "Ziama Mansouriah"] },
      { state: "Sétif", cities: ["Sétif", "El Eulma", "Ain Oulmene", "Bougaa", "Ain Azel"] },
      { state: "Saïda", cities: ["Saïda", "Ain El Hadjar", "Sidi Boubekeur", "Ouled Brahim", "Youb"] },
      { state: "Skikda", cities: ["Skikda", "Azzaba", "Collo", "Tamalous", "El Hadaiek"] },
      { state: "Sidi Bel Abbès", cities: ["Sidi Bel Abbès", "Telagh", "Sfisef", "Ben Badis", "Marhoum"] },
      { state: "Annaba", cities: ["Annaba", "El Bouni", "El Hadjar", "Ain Berda", "Berrahal"] },
      { state: "Guelma", cities: ["Guelma", "Héliopolis", "Boumahra Ahmed", "Oued Zenati", "Ain Makhlouf"] },
      { state: "Constantine", cities: ["Constantine", "El Khroub", "Ain Smara", "Hamma Bouziane", "Didouche Mourad"] },
      { state: "Médéa", cities: ["Médéa", "Berrouaghia", "Ksar El Boukhari", "Ouamri", "Chahbounia"] },
      { state: "Mostaganem", cities: ["Mostaganem", "Ain Tedles", "Sidi Ali", "Sidi Lakhdar", "Bouguirat"] },
      { state: "M'Sila", cities: ["M'Sila", "Bou Saada", "Sidi Aissa", "Ain El Melh", "Magra"] },
      { state: "Mascara", cities: ["Mascara", "Sig", "Tighennif", "Mohammadia", "Ghriss"] },
      { state: "Ouargla", cities: ["Ouargla", "Hassi Messaoud", "Touggourt", "El Hadjira", "N'Goussa"] },
      { state: "Oran", cities: ["Oran", "Es Senia", "Bir El Djir", "Arzew", "Bethioua"] },
      { state: "El Bayadh", cities: ["El Bayadh", "Brezoina", "Chellala", "Rogassa", "Boussemghoun"] },
      { state: "Illizi", cities: ["Illizi", "Djanet", "In Amenas", "Bordj Omar Driss", "Ohanet"] },
      { state: "Bordj Bou Arréridj", cities: ["Bordj Bou Arréridj", "Ras El Oued", "Bordj Ghedir", "El Hamadia", "Mansoura"] },
      { state: "Boumerdès", cities: ["Boumerdès", "Boudouaou", "Dellys", "Khemis El Khechna", "Thenia"] },
      { state: "El Tarf", cities: ["El Tarf", "El Kala", "Bouteldja", "Ben M'Hidi", "Besbes"] },
      { state: "Tindouf", cities: ["Tindouf", "Oum El Assel"] },
      { state: "Tissemsilt", cities: ["Tissemsilt", "Lardjem", "Theniet El Had", "Khemisti", "Bordj Bounaama"] },
      { state: "El Oued", cities: ["El Oued", "Robbah", "Guemar", "Debila", "Hassi Khalifa"] },
      { state: "Khenchela", cities: ["Khenchela", "Ain Touila", "Kais", "Chechar", "Ouled Rechache"] },
      { state: "Souk Ahras", cities: ["Souk Ahras", "Sedrata", "M'daourouch", "Merahna", "Ouled Driss"] },
      { state: "Tipaza", cities: ["Tipaza", "Cherchell", "Hadjout", "Gouraya", "Kolea"] },
      { state: "Mila", cities: ["Mila", "Chelghoum Laid", "Ferdjioua", "Grarem Gouga", "Sidi Merouane"] },
      { state: "Ain Defla", cities: ["Ain Defla", "Khemis Miliana", "El Attaf", "Miliana", "Djendel"] },
      { state: "Naama", cities: ["Naama", "Mecheria", "Ain Sefra", "Sfissifa", "Asla"] },
      { state: "Ain Temouchent", cities: ["Ain Temouchent", "Hammam Bou Hadjar", "El Malah", "Beni Saf", "El Amria"] },
      { state: "Ghardaia", cities: ["Ghardaia", "Metlili", "El Meniaa", "Berriane", "Zelfana"] },
      { state: "Relizane", cities: ["Relizane", "Oued Rhiou", "Ammi Moussa", "Djidioua", "Yellel"] },
      { state: "Timimoun", cities: ["Timimoun", "Charouine", "Ouled Said", "Tinerkouk", "Ksar Kaddour"] },
      { state: "Bordj Badji Mokhtar", cities: ["Bordj Badji Mokhtar", "Timiaouine"] },
      { state: "Ouled Djellal", cities: ["Ouled Djellal", "Sidi Khaled", "Besbes", "Doucen"] },
      { state: "Béni Abbès", cities: ["Béni Abbès", "Igli", "El Ouata", "Tabelbala"] },
      { state: "In Salah", cities: ["In Salah", "Foggaret Ezzoua", "In Ghar"] },
      { state: "In Guezzam", cities: ["In Guezzam", "Tin Zaouatine"] },
      { state: "Touggourt", cities: ["Touggourt", "Temacine", "Megarine", "Nezla"] },
      { state: "Djanet", cities: ["Djanet", "Bordj El Haouas"] },
      { state: "El M'Ghair", cities: ["El M'Ghair", "Djamaa", "Sidi Amrane"] },
      { state: "El Menia", cities: ["El Menia", "Hassi Gara", "Hassi Fehal"] },
    ],
  },
  {
    country: "Andorra",
    states: [
      { state: "Andorra la Vella", cities: ["Andorra la Vella"] },
      { state: "Canillo", cities: ["Canillo", "El Tarter", "Soldeu"] },
      { state: "Encamp", cities: ["Encamp", "Pas de la Casa"] },
      { state: "Escaldes-Engordany", cities: ["Escaldes-Engordany", "Les Escaldes"] },
      { state: "La Massana", cities: ["La Massana", "Arinsal", "Pal"] },
      { state: "Ordino", cities: ["Ordino", "El Serrat", "Llorts"] },
      { state: "Sant Julià de Lòria", cities: ["Sant Julià de Lòria", "Aixovall"] },
    ],
  },
  {
    country: "Angola",
    states: [
      { state: "Bengo", cities: ["Caxito", "N'dalatando", "Ambriz"] },
      { state: "Benguela", cities: ["Benguela", "Lobito", "Catumbela"] },
      { state: "Bié", cities: ["Kuito", "Camacupa", "Catabola"] },
      { state: "Cabinda", cities: ["Cabinda", "Cacongo", "Miconje"] },
      { state: "Cunene", cities: ["Ondjiva", "Xangongo", "Namacunde"] },
      { state: "Huambo", cities: ["Huambo", "Caála", "Longonjo"] },
      { state: "Huíla", cities: ["Lubango", "Humpata", "Matala"] },
      { state: "Kwanza Norte", cities: ["N'dalatando", "Lucala", "Cazengo"] },
      { state: "Kwanza Sul", cities: ["Sumbe", "Porto Amboim", "Quibala"] },
      { state: "Luanda", cities: ["Luanda", "Viana", "Cacuaco"] },
      { state: "Lunda Norte", cities: ["Dundo", "Lucapa", "Cuango"] },
      { state: "Lunda Sul", cities: ["Saurimo", "Muconda", "Cacolo"] },
      { state: "Malanje", cities: ["Malanje", "Cacuso", "Calandula"] },
      { state: "Moxico", cities: ["Luena", "Cameia", "Léua"] },
      { state: "Namibe", cities: ["Moçâmedes", "Tômbwa", "Virei"] },
      { state: "Uíge", cities: ["Uíge", "Negage", "Maquela do Zombo"] },
      { state: "Zaire", cities: ["M'banza-Kongo", "Soyo", "Nzeto"] },
      { state: "Cuando Cubango", cities: ["Menongue", "Cuito Cuanavale", "Mavinga"] },
    ],
  },
  {
    country: "Antigua and Barbuda",
    states: [
      { state: "Saint John", cities: ["St. John's", "All Saints", "Liberta"] },
      { state: "Saint George", cities: ["Piggotts", "Parham", "Fitches Creek"] },
      { state: "Saint Peter", cities: ["Parham", "Pares", "Willikies"] },
      { state: "Saint Philip", cities: ["Willikies", "Freetown", "Willing"] },
      { state: "Saint Paul", cities: ["Falmouth", "English Harbour", "Cobbs Cross"] },
      { state: "Saint Mary", cities: ["Bolans", "Jolly Harbour", "Urlings"] },
      { state: "Barbuda", cities: ["Codrington"] },
      { state: "Redonda", cities: [] }, // Uninhabited
    ],
  },
  {
    country: "Argentina",
    states: [
      { state: "Buenos Aires", cities: ["La Plata", "Mar del Plata", "Bahía Blanca", "Quilmes", "Lanús"] },
      { state: "Catamarca", cities: ["San Fernando del Valle de Catamarca", "Recreo", "Tinogasta"] },
      { state: "Chaco", cities: ["Resistencia", "Presidencia Roque Sáenz Peña", "Barranqueras"] },
      { state: "Chubut", cities: ["Comodoro Rivadavia", "Trelew", "Puerto Madryn"] },
      { state: "Córdoba", cities: ["Córdoba", "Río Cuarto", "Villa María"] },
      { state: "Corrientes", cities: ["Corrientes", "Goya", "Mercedes"] },
      { state: "Entre Ríos", cities: ["Paraná", "Concordia", "Gualeguaychú"] },
      { state: "Formosa", cities: ["Formosa", "Clorinda", "Pirané"] },
      { state: "Jujuy", cities: ["San Salvador de Jujuy", "Palpalá", "Libertador General San Martín"] },
      { state: "La Pampa", cities: ["Santa Rosa", "General Pico", "Realicó"] },
      { state: "La Rioja", cities: ["La Rioja", "Chilecito", "Aimogasta"] },
      { state: "Mendoza", cities: ["Mendoza", "San Rafael", "Godoy Cruz"] },
      { state: "Misiones", cities: ["Posadas", "Oberá", "Eldorado"] },
      { state: "Neuquén", cities: ["Neuquén", "Cipolletti", "Plottier"] },
      { state: "Río Negro", cities: ["Viedma", "General Roca", "San Carlos de Bariloche"] },
      { state: "Salta", cities: ["Salta", "Tartagal", "Orán"] },
      { state: "San Juan", cities: ["San Juan", "Rivadavia", "Chimbas"] },
      { state: "San Luis", cities: ["San Luis", "Villa Mercedes", "Merlo"] },
      { state: "Santa Cruz", cities: ["Río Gallegos", "Caleta Olivia", "Pico Truncado"] },
      { state: "Santa Fe", cities: ["Santa Fe", "Rosario", "Rafaela"] },
      { state: "Santiago del Estero", cities: ["Santiago del Estero", "La Banda", "Añatuya"] },
      { state: "Tierra del Fuego", cities: ["Ushuaia", "Río Grande", "Tolhuin"] },
      { state: "Tucumán", cities: ["San Miguel de Tucumán", "Tafí Viejo", "Yerba Buena"] },
      { state: "Ciudad Autónoma de Buenos Aires", cities: ["Buenos Aires"] },
    ],
  },
  {
    country: "Australia",
    states: [
      { state: "New South Wales", cities: ["Sydney", "Newcastle", "Wollongong", "Maitland", "Wagga Wagga"] },
      { state: "Victoria", cities: ["Melbourne", "Geelong", "Ballarat", "Bendigo", "Shepparton"] },
      { state: "Queensland", cities: ["Brisbane", "Gold Coast", "Townsville", "Cairns", "Toowoomba"] },
      { state: "Western Australia", cities: ["Perth", "Fremantle", "Bunbury", "Kalgoorlie", "Albany"] },
      { state: "South Australia", cities: ["Adelaide", "Mount Gambier", "Whyalla", "Murray Bridge", "Port Lincoln"] },
      { state: "Tasmania", cities: ["Hobart", "Launceston", "Devonport", "Burnie", "Clarence"] },
      { state: "Australian Capital Territory", cities: ["Canberra", "Queanbeyan"] },
      { state: "Northern Territory", cities: ["Darwin", "Alice Springs", "Palmerston", "Katherine"] },
    ],
  },
  {
    country: "Panama",
    states: [
      { state: "Bocas del Toro", cities: ["Bocas Town", "Changuinola", "Almirante", "Guabito"] },
      { state: "Chiriquí", cities: ["David", "Boquete", "Volcán", "Puerto Armuelles", "Bugaba"] },
      { state: "Coclé", cities: ["Penonomé", "Aguadulce", "Antón", "Natá", "La Pintada"] },
      { state: "Colón", cities: ["Colón", "Sabanitas", "Puerto Pilón", "Cativá", "Gatún"] },
      { state: "Darién", cities: ["La Palma", "Yaviza", "Metetí", "Santa Fé", "Garachiné"] },
      { state: "Herrera", cities: ["Chitré", "Las Minas", "Pesé", "Ocú", "Parita"] },
      { state: "Los Santos", cities: ["Las Tablas", "Macaracas", "Pedasí", "Tonosí", "Guararé"] },
      { state: "Panamá", cities: ["Panama City", "San Miguelito", "Arraiján", "La Chorrera", "Tocumen"] },
      { state: "Veraguas", cities: ["Santiago de Veraguas", "La Mesa", "Soná", "Cañazas", "Atalaya"] },
      { state: "Panamá Oeste", cities: ["La Chorrera", "Capira", "Chame", "San Carlos", "Antón"] },
      { state: "Emberá-Wounaan", cities: ["Unión Chocó", "Sambú"] },
      { state: "Guna Yala", cities: ["El Porvenir", "Narganá", "Ailigandí"] },
      { state: "Ngäbe-Buglé", cities: ["San Félix", "Kusapín", "Besikó"] },
    ],
  },
  {
    country: "India",
    states: [
      { state: "Andhra Pradesh", cities: ["Visakhapatnam", "Vijayawada", "Guntur", "Nellore", "Kurnool"] },
      { state: "Arunachal Pradesh", cities: ["Itanagar", "Naharlagun", "Pasighat", "Tawang", "Ziro"] },
      { state: "Assam", cities: ["Guwahati", "Dibrugarh", "Silchar", "Jorhat", "Nagaon"] },
      { state: "Bihar", cities: ["Patna", "Gaya", "Muzaffarpur", "Bhagalpur", "Purnia"] },
      { state: "Chhattisgarh", cities: ["Raipur", "Bhilai", "Bilaspur", "Korba", "Durg"] },
      { state: "Goa", cities: ["Panaji", "Margao", "Vasco da Gama", "Mapusa", "Ponda"] },
      { state: "Gujarat", cities: ["Ahmedabad", "Surat", "Vadodara", "Rajkot", "Gandhinagar"] },
      { state: "Haryana", cities: ["Chandigarh", "Faridabad", "Gurugram", "Hisar", "Karnal"] },
      { state: "Himachal Pradesh", cities: ["Shimla", "Mandi", "Dharamshala", "Solan", "Kullu"] },
      { state: "Jharkhand", cities: ["Ranchi", "Jamshedpur", "Dhanbad", "Bokaro", "Hazaribagh"] },
      { state: "Karnataka", cities: ["Bengaluru", "Mysore", "Hubli", "Mangalore", "Belgaum"] },
      { state: "Kerala", cities: ["Thiruvananthapuram", "Kochi", "Kozhikode", "Thrissur", "Kollam"] },
      { state: "Madhya Pradesh", cities: ["Bhopal", "Indore", "Jabalpur", "Gwalior", "Ujjain"] },
      { state: "Maharashtra", cities: ["Mumbai", "Pune", "Nagpur", "Nashik", "Aurangabad"] },
      { state: "Manipur", cities: ["Imphal", "Thoubal", "Bishnupur", "Churachandpur", "Kakching"] },
      { state: "Meghalaya", cities: ["Shillong", "Tura", "Nongpoh", "Jowai", "Nongstoin"] },
      { state: "Mizoram", cities: ["Aizawl", "Lunglei", "Champhai", "Saiha", "Kolasib"] },
      { state: "Nagaland", cities: ["Kohima", "Dimapur", "Mokokchung", "Wokha", "Tuensang"] },
      { state: "Odisha", cities: ["Bhubaneswar", "Cuttack", "Rourkela", "Berhampur", "Sambalpur"] },
      { state: "Punjab", cities: ["Chandigarh", "Ludhiana", "Amritsar", "Jalandhar", "Patiala"] },
      { state: "Rajasthan", cities: ["Jaipur", "Jodhpur", "Udaipur", "Kota", "Ajmer"] },
      { state: "Sikkim", cities: ["Gangtok", "Namchi", "Jorethang", "Mangan", "Gyalshing"] },
      { state: "Tamil Nadu", cities: ["Chennai", "Coimbatore", "Madurai", "Tiruchirappalli", "Salem"] },
      { state: "Telangana", cities: ["Hyderabad", "Warangal", "Nizamabad", "Khammam", "Karimnagar"] },
      { state: "Tripura", cities: ["Agartala", "Udaipur", "Dharmanagar", "Ambassa", "Kailasahar"] },
      { state: "Uttar Pradesh", cities: ["Lucknow", "Kanpur", "Agra", "Varanasi", "Meerut"] },
      { state: "Uttarakhand", cities: ["Dehradun", "Haridwar", "Roorkee", "Haldwani", "Rudrapur"] },
      { state: "West Bengal", cities: ["Kolkata", "Howrah", "Durgapur", "Siliguri", "Asansol"] },
      { state: "Andaman and Nicobar Islands", cities: ["Port Blair", "Garacharma", "Bambooflat"] },
      { state: "Chandigarh", cities: ["Chandigarh"] },
      { state: "Dadra and Nagar Haveli and Daman and Diu", cities: ["Daman", "Diu", "Silvassa"] },
      { state: "Delhi", cities: ["New Delhi", "Delhi", "Noida", "Gurgaon", "Faridabad"] },
      { state: "Jammu and Kashmir", cities: ["Srinagar", "Jammu", "Anantnag", "Baramulla", "Kathua"] },
      { state: "Ladakh", cities: ["Leh", "Kargil"] },
      { state: "Lakshadweep", cities: ["Kavaratti", "Minicoy", "Andrott"] },
      { state: "Puducherry", cities: ["Puducherry", "Karaikal", "Mahe", "Yanam"] },
    ],
  },
  {
    country: "United States",
    states: [
      { state: "Alabama", cities: ["Birmingham", "Montgomery", "Mobile", "Huntsville", "Tuscaloosa"] },
      { state: "Alaska", cities: ["Anchorage", "Fairbanks", "Juneau", "Sitka", "Ketchikan"] },
      { state: "Arizona", cities: ["Phoenix", "Tucson", "Mesa", "Chandler", "Scottsdale"] },
      { state: "Arkansas", cities: ["Little Rock", "Fort Smith", "Fayetteville", "Springdale", "Jonesboro"] },
      { state: "California", cities: ["Los Angeles", "San Francisco", "San Diego", "San Jose", "Sacramento"] },
      { state: "Colorado", cities: ["Denver", "Colorado Springs", "Aurora", "Fort Collins", "Lakewood"] },
      { state: "Connecticut", cities: ["Bridgeport", "New Haven", "Hartford", "Stamford", "Waterbury"] },
      { state: "Delaware", cities: ["Wilmington", "Dover", "Newark", "Middletown", "Smyrna"] },
      { state: "Florida", cities: ["Miami", "Orlando", "Tampa", "Jacksonville", "St. Petersburg"] },
      { state: "Georgia", cities: ["Atlanta", "Savannah", "Augusta", "Columbus", "Macon"] },
      { state: "Hawaii", cities: ["Honolulu", "Hilo", "Kailua", "Kapolei", "Kaneohe"] },
      { state: "Idaho", cities: ["Boise", "Nampa", "Meridian", "Idaho Falls", "Pocatello"] },
      { state: "Illinois", cities: ["Chicago", "Aurora", "Rockford", "Joliet", "Naperville"] },
      { state: "Indiana", cities: ["Indianapolis", "Fort Wayne", "Evansville", "South Bend", "Carmel"] },
      { state: "Iowa", cities: ["Des Moines", "Cedar Rapids", "Davenport", "Sioux City", "Iowa City"] },
      { state: "Kansas", cities: ["Wichita", "Overland Park", "Kansas City", "Topeka", "Olathe"] },
      { state: "Kentucky", cities: ["Louisville", "Lexington", "Bowling Green", "Owensboro", "Covington"] },
      { state: "Louisiana", cities: ["New Orleans", "Baton Rouge", "Shreveport", "Lafayette", "Lake Charles"] },
      { state: "Maine", cities: ["Portland", "Lewiston", "Bangor", "South Portland", "Auburn"] },
      { state: "Maryland", cities: ["Baltimore", "Columbia", "Annapolis", "Frederick", "Rockville"] },
      { state: "Massachusetts", cities: ["Boston", "Worcester", "Springfield", "Cambridge", "Lowell"] },
      { state: "Michigan", cities: ["Detroit", "Grand Rapids", "Warren", "Sterling Heights", "Ann Arbor"] },
      { state: "Minnesota", cities: ["Minneapolis", "Saint Paul", "Rochester", "Duluth", "Bloomington"] },
      { state: "Mississippi", cities: ["Jackson", "Gulfport", "Southaven", "Biloxi", "Hattiesburg"] },
      { state: "Missouri", cities: ["Kansas City", "St. Louis", "Springfield", "Columbia", "Independence"] },
      { state: "Montana", cities: ["Billings", "Missoula", "Great Falls", "Bozeman", "Butte"] },
      { state: "Nebraska", cities: ["Omaha", "Lincoln", "Bellevue", "Grand Island", "Kearney"] },
      { state: "Nevada", cities: ["Las Vegas", "Reno", "Henderson", "North Las Vegas", "Sparks"] },
      { state: "New Hampshire", cities: ["Manchester", "Nashua", "Concord", "Dover", "Rochester"] },
      { state: "New Jersey", cities: ["Newark", "Jersey City", "Paterson", "Elizabeth", "Trenton"] },
      { state: "New Mexico", cities: ["Albuquerque", "Las Cruces", "Santa Fe", "Rio Rancho", "Roswell"] },
      { state: "New York", cities: ["New York City", "Buffalo", "Rochester", "Yonkers", "Syracuse"] },
      { state: "North Carolina", cities: ["Charlotte", "Raleigh", "Greensboro", "Durham", "Winston-Salem"] },
      { state: "North Dakota", cities: ["Fargo", "Bismarck", "Grand Forks", "Minot", "West Fargo"] },
      { state: "Ohio", cities: ["Columbus", "Cleveland", "Cincinnati", "Toledo", "Akron"] },
      { state: "Oklahoma", cities: ["Oklahoma City", "Tulsa", "Norman", "Broken Arrow", "Edmond"] },
      { state: "Oregon", cities: ["Portland", "Eugene", "Salem", "Gresham", "Hillsboro"] },
      { state: "Pennsylvania", cities: ["Philadelphia", "Pittsburgh", "Allentown", "Erie", "Reading"] },
      { state: "Rhode Island", cities: ["Providence", "Warwick", "Cranston", "Pawtucket", "East Providence"] },
      { state: "South Carolina", cities: ["Columbia", "Charleston", "Greenville", "Myrtle Beach", "Spartanburg"] },
      { state: "South Dakota", cities: ["Sioux Falls", "Rapid City", "Aberdeen", "Brookings", "Watertown"] },
      { state: "Tennessee", cities: ["Nashville", "Memphis", "Knoxville", "Chattanooga", "Clarksville"] },
      { state: "Texas", cities: ["Houston", "Dallas", "Austin", "San Antonio", "Fort Worth"] },
      { state: "Utah", cities: ["Salt Lake City", "West Valley City", "Provo", "West Jordan", "Orem"] },
      { state: "Vermont", cities: ["Burlington", "South Burlington", "Rutland", "Barre", "Montpelier"] },
      { state: "Virginia", cities: ["Virginia Beach", "Norfolk", "Richmond", "Chesapeake", "Arlington"] },
      { state: "Washington", cities: ["Seattle", "Spokane", "Tacoma", "Vancouver", "Bellevue"] },
      { state: "West Virginia", cities: ["Charleston", "Huntington", "Morgantown", "Parkersburg", "Wheeling"] },
      { state: "Wisconsin", cities: ["Milwaukee", "Madison", "Green Bay", "Kenosha", "Racine"] },
      { state: "Wyoming", cities: ["Cheyenne", "Casper", "Laramie", "Gillette", "Rock Springs"] },
      { state: "District of Columbia", cities: ["Washington, D.C."] },
      { state: "Puerto Rico", cities: ["San Juan", "Bayamón", "Carolina", "Ponce", "Caguas"] },
      { state: "Guam", cities: ["Hagåtña", "Dededo", "Tamuning"] },
      { state: "U.S. Virgin Islands", cities: ["Charlotte Amalie", "Christiansted", "Frederiksted"] },
      { state: "American Samoa", cities: ["Pago Pago", "Tāfuna", "Nu'uuli"] },
      { state: "Northern Mariana Islands", cities: ["Saipan", "Tinian", "Rota"] },
    ],
  },
  {
    country: "United Kingdom",
    states: [
      { state: "England", cities: ["London", "Manchester", "Birmingham", "Liverpool", "Bristol", "Leeds", "Sheffield"] },
      { state: "Scotland", cities: ["Edinburgh", "Glasgow", "Aberdeen", "Dundee", "Inverness", "Stirling"] },
      { state: "Wales", cities: ["Cardiff", "Swansea", "Newport", "Wrexham", "Bangor", "Barry"] },
      { state: "Northern Ireland", cities: ["Belfast", "Londonderry", "Newry", "Armagh", "Lisburn"] },
    ],
  },
  {
    country: "Romania",
    states: [
      { state: "Alba", cities: ["Alba Iulia", "Aiud", "Sebeș", "Blaj", "Cugir"] },
      { state: "Arad", cities: ["Arad", "Ineu", "Lipova", "Pâncota", "Curtici"] },
      { state: "Argeș", cities: ["Pitești", "Câmpulung", "Mioveni", "Curtea de Argeș", "Topoloveni"] },
      { state: "Bacău", cities: ["Bacău", "Moinești", "Comănești", "Onești", "Târgu Ocna"] },
      { state: "Bihor", cities: ["Oradea", "Salonta", "Marghita", "Beiuș", "Aleşd"] },
      { state: "Bistrița-Năsăud", cities: ["Bistrița", "Beclean", "Năsăud", "Sângeorz-Băi"] },
      { state: "Botoșani", cities: ["Botoșani", "Dorohoi", "Săveni", "Flămânzi", "Darabani"] },
      { state: "Brașov", cities: ["Brașov", "Râșnov", "Codlea", "Făgăraș", "Săcele"] },
      { state: "Brăila", cities: ["Brăila", "Ianca", "Făurei", "Însurăței"] },
      { state: "Buzău", cities: ["Buzău", "Râmnicu Sărat", "Nehoiu", "Pogoanele", "Pătârlagele"] },
      { state: "Caraș-Severin", cities: ["Reșița", "Caransebeș", "Oravița", "Anina", "Băile Herculane"] },
      { state: "Călărași", cities: ["Călărași", "Oltenița", "Fetești", "Budești", "Lehliu Gară"] },
      { state: "Cluj", cities: ["Cluj-Napoca", "Turda", "Dej", "Câmpia Turzii", "Gherla"] },
      { state: "Constanța", cities: ["Constanța", "Mangalia", "Medgidia", "Năvodari", "Cernavodă"] },
      { state: "Covasna", cities: ["Sfântu Gheorghe", "Târgu Secuiesc", "Baraolt", "Covasna", "Întorsura Buzăului"] },
      { state: "Dâmbovița", cities: ["Târgoviște", "Moreni", "Pucioasa", "Găești", "Titu"] },
      { state: "Dolj", cities: ["Craiova", "Băilești", "Dăbuleni", "Filiași", "Calafat"] },
      { state: "Galați", cities: ["Galați", "Târgu Bujor", "Berești", "Tecuci"] },
      { state: "Giurgiu", cities: ["Giurgiu", "Bolintin-Vale", "Mihăilești", "Băneasa", "Hotarele"] },
      { state: "Gorj", cities: ["Târgu Jiu", "Motru", "Rovinari", "Bumbești-Jiu", "Târgu Cărbunești"] },
      { state: "Harghita", cities: ["Miercurea Ciuc", "Odorheiu Secuiesc", "Gheorgheni", "Cristuru Secuiesc", "Băile Tușnad"] },
      { state: "Hunedoara", cities: ["Deva", "Hunedoara", "Petroșani", "Vulcan", "Lupeni"] },
      { state: "Ialomița", cities: ["Slobozia", "Fetești", "Urziceni", "Țăndărei", "Amara"] },
      { state: "Iași", cities: ["Iași", "Pașcani", "Târgu Frumos", "Hârlău", "Podu Iloaiei"] },
      { state: "Ilfov", cities: ["Voluntari", "Buftea", "Pantelimon", "Popești-Leordeni", "Chitila"] },
      { state: "Maramureș", cities: ["Baia Mare", "Sighetu Marmației", "Baia Sprie", "Borșa", "Vișeu de Sus"] },
      { state: "Mehedinți", cities: ["Drobeta-Turnu Severin", "Orșova", "Strehaia", "Baia de Aramă", "Vânju Mare"] },
      { state: "Mureș", cities: ["Târgu Mureș", "Sighișoara", "Reghin", "Târnăveni", "Luduș"] },
      { state: "Neamț", cities: ["Piatra Neamț", "Roman", "Târgu Neamț", "Bicaz", "Roznov"] },
      { state: "Olt", cities: ["Slatina", "Caracal", "Piatra-Olt", "Balș", "Corabia"] },
      { state: "Prahova", cities: ["Ploiești", "Câmpina", "Sinaia", "Băicoi", "Breaza"] },
      { state: "Satu Mare", cities: ["Satu Mare", "Carei", "Negrești-Oaș", "Tășnad", "Livada"] },
      { state: "Sălaj", cities: ["Zalău", "Șimleu Silvaniei", "Jibou", "Cehu Silvaniei"] },
      { state: "Sibiu", cities: ["Sibiu", "Mediaș", "Cisnădie", "Avrig", "Dumbrăveni"] },
      { state: "Suceava", cities: ["Suceava", "Fălticeni", "Rădăuți", "Câmpulung Moldovenesc", "Vatra Dornei"] },
      { state: "Teleorman", cities: ["Alexandria", "Roșiorii de Vede", "Zimnicea", "Turnu Măgurele", "Videle"] },
      { state: "Timiș", cities: ["Timișoara", "Lugoj", "Recaș", "Jimbolia", "Sânnicolau Mare"] },
      { state: "Tulcea", cities: ["Tulcea", "Babadag", "Isaccea", "Măcin", "Sulina"] },
      { state: "Vaslui", cities: ["Vaslui", "Bârlad", "Huși", "Negrești", "Murgeni"] },
      { state: "Vâlcea", cities: ["Râmnicu Vâlcea", "Drăgășani", "Băbeni", "Călimănești", "Băile Olănești"] },
      { state: "Vrancea", cities: ["Focșani", "Adjud", "Mărășești", "Panciu", "Odobești"] },
      { state: "Bucharest", cities: ["Bucharest"] },
    ],
  },
  {
    country: "Armenia",
    states: [
      { state: "Yerevan", cities: ["Yerevan"] },
      { state: "Aragatsotn", cities: ["Ashtarak", "Aparan", "Talin"] },
      { state: "Ararat", cities: ["Artashat", "Ararat", "Masis"] },
      { state: "Armavir", cities: ["Armavir", "Vagharshapat", "Metsamor"] },
      { state: "Gegharkunik", cities: ["Gavar", "Sevan", "Vardenis"] },
      { state: "Kotayk", cities: ["Hrazdan", "Abovyan", "Yeghvard"] },
      { state: "Lori", cities: ["Vanadzor", "Alaverdi", "Stepanavan"] },
      { state: "Shirak", cities: ["Gyumri", "Artik", "Maralik"] },
      { state: "Syunik", cities: ["Kapan", "Goris", "Sisian"] },
      { state: "Tavush", cities: ["Ijevan", "Dilijan", "Noyemberyan"] },
      { state: "Vayots Dzor", cities: ["Yeghegnadzor", "Vayk", "Jermuk"] },
    ],
  },
  {
    country: "Austria",
    states: [
      { state: "Burgenland", cities: ["Eisenstadt", "Oberwart", "Neusiedl am See"] },
      { state: "Carinthia", cities: ["Klagenfurt", "Villach", "Wolfsberg"] },
      { state: "Lower Austria", cities: ["St. Pölten", "Wiener Neustadt", "Krems an der Donau"] },
      { state: "Upper Austria", cities: ["Linz", "Wels", "Steyr"] },
      { state: "Salzburg", cities: ["Salzburg", "Hallein", "Saalfelden"] },
      { state: "Styria", cities: ["Graz", "Leoben", "Kapfenberg"] },
      { state: "Tyrol", cities: ["Innsbruck", "Kufstein", "Kitzbühel"] },
      { state: "Vorarlberg", cities: ["Bregenz", "Dornbirn", "Feldkirch"] },
      { state: "Vienna", cities: ["Vienna"] },
    ],
  },
  {
    country: "Azerbaijan",
    states: [
      { state: "Absheron", cities: ["Khirdalan", "Sumqayit", "Baku"] },
      { state: "Ganja-Gazakh", cities: ["Ganja", "Shamkir", "Tovuz"] },
      { state: "Lankaran", cities: ["Lankaran", "Masalli", "Lerik"] },
      { state: "Quba-Khachmaz", cities: ["Quba", "Khachmaz", "Qusar"] },
      { state: "Shaki-Zagatala", cities: ["Shaki", "Zagatala", "Qakh"] },
      { state: "Upper Karabakh", cities: ["Stepanakert", "Shusha", "Martuni"] },
      { state: "Kalbajar-Lachin", cities: ["Kalbajar", "Lachin"] },
      { state: "Aran", cities: ["Yevlakh", "Barda", "Goychay"] },
      { state: "Nakhchivan", cities: ["Nakhchivan", "Ordubad", "Julfa"] },
    ],
  },
  {
    country: "Bahamas",
    states: [
      { state: "New Providence", cities: ["Nassau"] },
      { state: "Grand Bahama", cities: ["Freeport", "West End", "High Rock"] },
      { state: "Abaco", cities: ["Marsh Harbour", "Treasure Cay", "Coopers Town"] },
      { state: "Andros", cities: ["Andros Town", "Nicholls Town", "Fresh Creek"] },
      { state: "Eleuthera", cities: ["Governor's Harbour", "Rock Sound", "Tarpum Bay"] },
      { state: "Exuma", cities: ["George Town", "Staniel Cay"] },
      { state: "Bimini", cities: ["Alice Town"] },
      { state: "Cat Island", cities: ["Arthur's Town", "New Bight"] },
      { state: "Long Island", cities: ["Deadman's Cay", "Clarence Town"] },
      { state: "San Salvador", cities: ["Cockburn Town"] },
    ],
  },
  {
    country: "Bahrain",
    states: [
      { state: "Capital Governorate", cities: ["Manama", "Juffair", "Seef"] },
      { state: "Muharraq Governorate", cities: ["Muharraq", "Amwaj Islands", "Hidd"] },
      { state: "Northern Governorate", cities: ["Budaiya", "Diraz", "Hamad Town"] },
      { state: "Southern Governorate", cities: ["Riffa", "Awali", "Zallaq"] },
    ],
  },
  {
    country: "Bangladesh",
    states: [
      { state: "Dhaka", cities: ["Dhaka", "Narayanganj", "Savar"] },
      { state: "Chattogram", cities: ["Chattogram", "Cox's Bazar", "Rangunia"] },
      { state: "Khulna", cities: ["Khulna", "Jessore", "Satkhira"] },
      { state: "Rajshahi", cities: ["Rajshahi", "Natore", "Chapainawabganj"] },
      { state: "Barisal", cities: ["Barisal", "Patuakhali", "Bhola"] },
      { state: "Sylhet", cities: ["Sylhet", "Moulvibazar", "Habiganj"] },
      { state: "Rangpur", cities: ["Rangpur", "Dinajpur", "Saidpur"] },
      { state: "Mymensingh", cities: ["Mymensingh", "Netrokona", "Jamalpur"] },
    ],
  },
  {
    country: "Barbados",
    states: [
      { state: "Christ Church", cities: ["Oistins", "Hastings", "Worthing"] },
      { state: "Saint Michael", cities: ["Bridgetown", "Warrens"] },
      { state: "Saint Philip", cities: ["Six Cross Roads", "Crane"] },
      { state: "Saint James", cities: ["Holetown", "Speightstown"] },
      { state: "Saint Peter", cities: ["Speightstown", "Little Good Harbour"] },
      { state: "Saint Joseph", cities: ["Bathsheba"] },
      { state: "Saint Lucy", cities: ["Crab Hill"] },
      { state: "Saint Andrew", cities: ["Greenland"] },
      { state: "Saint George", cities: ["The Glebe"] },
      { state: "Saint John", cities: ["Four Cross Roads"] },
      { state: "Saint Thomas", cities: ["Welches"] },
    ],
  },
  {
    country: "Belarus",
    states: [
      { state: "Brest Region", cities: ["Brest", "Baranovichi", "Pinsk", "Kobrin", "Beryoza"] },
      { state: "Gomel Region", cities: ["Gomel", "Mozyr", "Zhlobin", "Svetlogorsk", "Rechitsa"] },
      { state: "Grodno Region", cities: ["Grodno", "Lida", "Slonim", "Volkovysk", "Smorgon"] },
      { state: "Minsk Region", cities: ["Minsk", "Borisov", "Soligorsk", "Molodechno", "Zhodino"] },
      { state: "Mogilev Region", cities: ["Mogilev", "Bobruisk", "Gorki", "Osipovichi", "Krichev"] },
      { state: "Vitebsk Region", cities: ["Vitebsk", "Orsha", "Novopolotsk", "Polotsk", "Glubokoye"] },
      { state: "Minsk City", cities: ["Minsk"] },
    ],
  },
  {
    country: "Belgium",
    states: [
      { state: "Antwerp", cities: ["Antwerp", "Mechelen", "Turnhout", "Geel", "Brasschaat"] },
      { state: "East Flanders", cities: ["Ghent", "Aalst", "Sint-Niklaas", "Dendermonde", "Lokeren"] },
      { state: "Flemish Brabant", cities: ["Leuven", "Vilvoorde", "Halle", "Tienen", "Aarschot"] },
      { state: "Limburg", cities: ["Hasselt", "Genk", "Sint-Truiden", "Beringen", "Tongeren"] },
      { state: "West Flanders", cities: ["Bruges", "Kortrijk", "Ostend", "Roeselare", "Ypres"] },
      { state: "Hainaut", cities: ["Charleroi", "Mons", "Tournai", "Mouscron", "La Louvière"] },
      { state: "Liège", cities: ["Liège", "Seraing", "Verviers", "Herstal", "Ans"] },
      { state: "Luxembourg", cities: ["Arlon", "Bastogne", "Marche-en-Famenne", "Virton", "Durbuy"] },
      { state: "Namur", cities: ["Namur", "Dinant", "Gembloux", "Andenne", "Ciney"] },
      { state: "Walloon Brabant", cities: ["Wavre", "Ottignies-Louvain-la-Neuve", "Nivelles", "Waterloo"] },
      { state: "Brussels-Capital Region", cities: ["Brussels", "Anderlecht", "Schaerbeek"] },
    ],
  },
  {
    country: "Belize",
    states: [
      { state: "Belize District", cities: ["Belize City", "San Pedro", "Ladyville"] },
      { state: "Cayo District", cities: ["San Ignacio", "Belmopan", "Benque Viejo del Carmen"] },
      { state: "Corozal District", cities: ["Corozal Town", "Sarteneja", "Progresso"] },
      { state: "Orange Walk District", cities: ["Orange Walk Town", "Yo Creek", "August Pine Ridge"] },
      { state: "Stann Creek District", cities: ["Dangriga", "Placencia", "Hopkins"] },
      { state: "Toledo District", cities: ["Punta Gorda", "San Antonio", "Mafredi"] },
    ],
  },
  {
    country: "Benin",
    states: [
      { state: "Alibori", cities: ["Kandi", "Banikoara", "Malanville"] },
      { state: "Atakora", cities: ["Natitingou", "Tanguiéta", "Boukoumbé"] },
      { state: "Atlantique", cities: ["Ouidah", "Allada", "Abomey-Calavi"] },
      { state: "Borgou", cities: ["Parakou", "Nikki", "Bembèrèkè"] },
      { state: "Collines", cities: ["Dassa-Zoumé", "Savalou", "Bantè"] },
      { state: "Couffo", cities: ["Dogbo", "Aplahoué", "Klouékanmè"] },
      { state: "Donga", cities: ["Djougou", "Bassila", "Copargo"] },
      { state: "Littoral", cities: ["Cotonou"] },
      { state: "Mono", cities: ["Lokossa", "Comè", "Grand-Popo"] },
      { state: "Ouémé", cities: ["Porto-Novo", "Adjarra", "Sèmè-Kpodji"] },
      { state: "Plateau", cities: ["Sakété", "Pobè", "Kétou"] },
      { state: "Zou", cities: ["Abomey", "Bohicon", "Covè"] },
    ],
  },
  {
    country: "Bhutan",
    states: [
      { state: "Bumthang", cities: ["Jakar", "Chhumey", "Tang"] },
      { state: "Chukha", cities: ["Phuentsholing", "Tsimasham", "Gedu"] },
      { state: "Dagana", cities: ["Dagapela", "Drujegang", "Lhamoy Zingkha"] },
      { state: "Gasa", cities: ["Gasa", "Laya"] },
      { state: "Haa", cities: ["Haa", "Sombaykha"] },
      { state: "Lhuntse", cities: ["Lhuntse", "Tsenkhar", "Gangzur"] },
      { state: "Mongar", cities: ["Mongar", "Yadi", "Gyalpozhing"] },
      { state: "Paro", cities: ["Paro", "Shaba", "Wangchang"] },
      { state: "Pemagatshel", cities: ["Pemagatshel", "Ngongshong", "Kherigonpa"] },
      { state: "Punakha", cities: ["Punakha", "Guma", "Lobesa"] },
      { state: "Samdrup Jongkhar", cities: ["Samdrup Jongkhar", "Dewathang", "Bhangtar"] },
      { state: "Samtse", cities: ["Samtse", "Gomtu", "Sipsu"] },
      { state: "Sarpang", cities: ["Sarpang", "Gelephu", "Lhamoy Zingkha"] },
      { state: "Thimphu", cities: ["Thimphu", "Dechencholing", "Kawang"] },
      { state: "Trashigang", cities: ["Trashigang", "Rangjung", "Khaling"] },
      { state: "Trashiyangtse", cities: ["Trashiyangtse", "Doksum", "Tsenkharla"] },
      { state: "Trongsa", cities: ["Trongsa", "Bjeezam", "Nubi"] },
      { state: "Tsirang", cities: ["Tsirang", "Damphu", "Sunkosh"] },
      { state: "Wangdue Phodrang", cities: ["Wangdue Phodrang", "Nobding", "Dangchu"] },
      { state: "Zhemgang", cities: ["Zhemgang", "Panbang", "Tingtibi"] },
    ],
  },
  {
    country: "Bolivia",
    states: [
      { state: "Beni", cities: ["Trinidad", "Riberalta", "Guayaramerín"] },
      { state: "Chuquisaca", cities: ["Sucre", "Camargo", "Monteagudo"] },
      { state: "Cochabamba", cities: ["Cochabamba", "Quillacollo", "Sacaba"] },
      { state: "La Paz", cities: ["La Paz", "El Alto", "Viacha"] },
      { state: "Oruro", cities: ["Oruro", "Huanuni", "Challapata"] },
      { state: "Pando", cities: ["Cobija", "Porvenir", "Puerto Rico"] },
      { state: "Potosí", cities: ["Potosí", "Uyuni", "Villazón"] },
      { state: "Santa Cruz", cities: ["Santa Cruz de la Sierra", "Montero", "Warnes"] },
      { state: "Tarija", cities: ["Tarija", "Yacuiba", "Villamontes"] },
    ],
  },
  {
    country: "Bosnia and Herzegovina",
    states: [
      { state: "Federation of Bosnia and Herzegovina", cities: ["Sarajevo", "Mostar", "Tuzla", "Zenica", "Bihać"] },
      { state: "Republika Srpska", cities: ["Banja Luka", "Bijeljina", "Prijedor", "Trebinje", "Doboj"] },
      { state: "Brčko District", cities: ["Brčko"] },
    ],
  },
  {
    country: "Botswana",
    states: [
      { state: "Central District", cities: ["Serowe", "Mahalapye", "Palapye"] },
      { state: "Chobe District", cities: ["Kasane", "Kachikau"] },
      { state: "Ghanzi District", cities: ["Ghanzi", "Charles Hill"] },
      { state: "Kgalagadi District", cities: ["Tsabong", "Hukuntsi"] },
      { state: "Kgatleng District", cities: ["Mochudi", "Molepolole"] },
      { state: "Kweneng District", cities: ["Molepolole", "Mogoditshane", "Gabane"] },
      { state: "North-East District", cities: ["Francistown", "Masunga"] },
      { state: "North-West District", cities: ["Maun", "Gumare", "Shakawe"] },
      { state: "South-East District", cities: ["Gaborone", "Ramotswa", "Mogoditshane"] },
      { state: "Southern District", cities: ["Kanye", "Jwaneng", "Moshupa"] },
    ],
  },
  {
    country: "Brazil",
    states: [
      { state: "Acre", cities: ["Rio Branco", "Cruzeiro do Sul", "Sena Madureira"] },
      { state: "Alagoas", cities: ["Maceió", "Arapiraca", "Palmeira dos Índios"] },
      { state: "Amapá", cities: ["Macapá", "Santana", "Laranjal do Jari"] },
      { state: "Amazonas", cities: ["Manaus", "Parintins", "Itacoatiara"] },
      { state: "Bahia", cities: ["Salvador", "Feira de Santana", "Vitória da Conquista"] },
      { state: "Ceará", cities: ["Fortaleza", "Juazeiro do Norte", "Caucaia"] },
      { state: "Distrito Federal", cities: ["Brasília"] },
      { state: "Espírito Santo", cities: ["Vitóri", "Vila Velha", "Serra"] },
      { state: "Goiás", cities: ["Goiânia", "Anápolis", "Aparecida de Goiânia"] },
      { state: "Maranhão", cities: ["São Luís", "Imperatriz", "Caxias"] },
      { state: "Mato Grosso", cities: ["Cuiabá", "Várzea Grande", "Rondonópolis"] },
      { state: "Mato Grosso do Sul", cities: ["Campo Grande", "Dourados", "Três Lagoas"] },
      { state: "Minas Gerais", cities: ["Belo Horizonte", "Uberlândia", "Contagem"] },
      { state: "Pará", cities: ["Belém", "Ananindeua", "Santarém"] },
      { state: "Paraíba", cities: ["João Pessoa", "Campina Grande", "Santa Rita"] },
      { state: "Paraná", cities: ["Curitiba", "Londrina", "Maringá"] },
      { state: "Pernambuco", cities: ["Recife", "Jaboatão dos Guararapes", "Olinda"] },
      { state: "Piauí", cities: ["Teresina", "Parnaíba", "Picos"] },
      { state: "Rio de Janeiro", cities: ["Rio de Janeiro", "Niterói", "Duque de Caxias"] },
      { state: "Rio Grande do Norte", cities: ["Natal", "Mossoró", "Parnamirim"] },
      { state: "Rio Grande do Sul", cities: ["Porto Alegre", "Caxias do Sul", "Pelotas"] },
      { state: "Rondônia", cities: ["Porto Velho", "Ji-Paraná", "Ariquemes"] },
      { state: "Roraima", cities: ["Boa Vista", "Rorainópolis", "Caracaraí"] },
      { state: "Santa Catarina", cities: ["Florianópolis", "Joinville", "Blumenau"] },
      { state: "São Paulo", cities: ["São Paulo", "Guarulhos", "Campinas"] },
      { state: "Sergipe", cities: ["Aracaju", "Nossa Senhora do Socorro", "Lagarto"] },
      { state: "Tocantins", cities: ["Palmas", "Araguaína", "Gurupi"] },
    ],
  },
  {
    country: "Brunei",
    states: [
      { state: "Belait", cities: ["Kuala Belait", "Seria", "Lumut"] },
      { state: "Brunei-Muara", cities: ["Bandar Seri Begawan", "Gadong", "Jerudong"] },
      { state: "Temburong", cities: ["Bangar", "Pekan Temburong"] },
      { state: "Tutong", cities: ["Tutong", "Lamunin", "Telisai"] },
    ],
  },
  {
    country: "Bulgaria",
    states: [
      { state: "Blagoevgrad", cities: ["Blagoevgrad", "Petrich", "Sandanski"] },
      { state: "Burgas", cities: ["Burgas", "Aytos", "Karnobat"] },
      { state: "Dobrich", cities: ["Dobrich", "Balchik", "Kavarna"] },
      { state: "Gabrovo", cities: ["Gabrovo", "Sevlievo", "Tryavna"] },
      { state: "Haskovo", cities: ["Haskovo", "Dimitrovgrad", "Svilengrad"] },
      { state: "Kardzhali", cities: ["Kardzhali", "Momchilgrad", "Krumovgrad"] },
      { state: "Kyustendil", cities: ["Kyustendil", "Dupnitsa", "Bobov Dol"] },
      { state: "Lovech", cities: ["Lovech", "Troyan", "Teteven"] },
      { state: "Montana", cities: ["Montana", "Vratsa", "Berkovitsa"] },
      { state: "Pazardzhik", cities: ["Pazardzhik", "Velingrad", "Peshtera"] },
      { state: "Pernik", cities: ["Pernik", "Radomir", "Breznik"] },
      { state: "Pleven", cities: ["Pleven", "Cherven Bryag", "Levski"] },
      { state: "Plovdiv", cities: ["Plovdiv", "Asenovgrad", "Karlovo"] },
      { state: "Razgrad", cities: ["Razgrad", "Isperih", "Kubrat"] },
      { state: "Ruse", cities: ["Ruse", "Byala", "Dve Mogili"] },
      { state: "Shumen", cities: ["Shumen", "Novi Pazar", "Veliki Preslav"] },
      { state: "Silistra", cities: ["Silistra", "Tutrakan", "Dulovo"] },
      { state: "Sliven", cities: ["Sliven", "Nova Zagora", "Kotel"] },
      { state: "Smolyan", cities: ["Smolyan", "Zlatograd", "Chepelare"] },
      { state: "Sofia City", cities: ["Sofia"] },
      { state: "Sofia Province", cities: ["Botevgrad", "Etropole", "Samokov"] },
      { state: "Stara Zagora", cities: ["Stara Zagora", "Kazanlak", "Chirpan"] },
      { state: "Targovishte", cities: ["Targovishte", "Popovo", "Omurtag"] },
      { state: "Varna", cities: ["Varna", "Devnya", "Provadia"] },
      { state: "Veliko Tarnovo", cities: ["Veliko Tarnovo", "Gorna Oryahovitsa", "Svishtov"] },
      { state: "Vidin", cities: ["Vidin", "Belogradchik", "Kula"] },
      { state: "Vratsa", cities: ["Vratsa", "Mezdra", "Kozloduy"] },
      { state: "Yambol", cities: ["Yambol", "Elhovo", "Straldzha"] },
    ],
  },
  {
    country: "Burkina Faso",
    states: [
      { state: "Balé", cities: ["Boromo", "Bagassi"] },
      { state: "Bam", cities: ["Kongoussi", "Sabce"] },
      { state: "Banwa", cities: ["Solenzo", "Tansila"] },
      { state: "Bazèga", cities: ["Kombissiri", "Saponé"] },
      { state: "Bougouriba", cities: ["Diébougou", "Tiankoura"] },
      { state: "Boulgou", cities: ["Tenkodogo", "Garango"] },
      { state: "Boulkiemdé", cities: ["Koudougou", "Nandiala"] },
      { state: "Comoé", cities: ["Banfora", "Orodara"] },
      { state: "Ganzourgou", cities: ["Zorgo", "Mogtédo"] },
      { state: "Gnagna", cities: ["Bogandé", "Bilanga"] },
      { state: "Gourma", cities: ["Fada N'gourma", "Diapaga"] },
      { state: "Houet", cities: ["Bobo-Dioulasso", "Orodara"] },
      { state: "Ioba", cities: ["Dano", "Dissin"] },
      { state: "Kadiogo", cities: ["Ouagadougou", "Tanghin-Dassouri"] },
      { state: "Kénédougou", cities: ["Orodara", "Samorogouan"] },
      { state: "Komondjari", cities: ["Gayeri", "Foutouri"] },
      { state: "Kompienga", cities: ["Pama", "Kompienga"] },
      { state: "Kossi", cities: ["Nouna", "Djibasso"] },
      { state: "Koulpélogo", cities: ["Ouargaye", "Lalgaye"] },
      { state: "Kouritenga", cities: ["Koupéla", "Pouytenga"] },
      { state: "Kourwéogo", cities: ["Boussé", "Laye"] },
      { state: "Léraba", cities: ["Sindou", "Douna"] },
      { state: "Loroum", cities: ["Titao", "Sollé"] },
      { state: "Mouhoun", cities: ["Dédougou", "Toma"] },
      { state: "Nahouri", cities: ["Pô", "Tiébélé"] },
      { state: "Namentenga", cities: ["Boulsa", "Tougouri"] },
      { state: "Nayala", cities: ["Toma", "Yaba"] },
      { state: "Noumbiel", cities: ["Batié", "Kampti"] },
      { state: "Oubritenga", cities: ["Ziniaré", "Loumbila"] },
      { state: "Oudalan", cities: ["Gorom-Gorom", "Markoye"] },
      { state: "Passoré", cities: ["Yako", "Arbollé"] },
      { state: "Poni", cities: ["Gaoua", "Bouroum-Bouroum"] },
      { state: "Sanguié", cities: ["Réo", "Didyr"] },
      { state: "Sanmatenga", cities: ["Kaya", "Barsalogho"] },
      { state: "Séno", cities: ["Dori", "Seytenga"] },
      { state: "Sissili", cities: ["Léo", "Biéha"] },
      { state: "Soum", cities: ["Djibo", "Arbinda"] },
      { state: "Sourou", cities: ["Tougan", "Di"] },
      { state: "Tapoa", cities: ["Diapaga", "Kantchari"] },
      { state: "Tuy", cities: ["Houndé", "Békuy"] },
      { state: "Yagha", cities: ["Sebba", "Solhan"] },
      { state: "Yatenga", cities: ["Ouahigouya", "Gourcy"] },
      { state: "Ziro", cities: ["Sapouy", "Cassou"] },
      { state: "Zondoma", cities: ["Gourcy", "Boussou"] },
      { state: "Zoundwéogo", cities: ["Manga", "Gogo"] },
    ],
  },
  {
    country: "Burundi",
    states: [
      { state: "Bubanza", cities: ["Bubanza", "Musenyi"] },
      { state: "Bujumbura Mairie", cities: ["Gitega", "Ngagara"] },
      { state: "Bujumbura Rural", cities: ["Isale", "Kabezi"] },
      { state: "Bururi", cities: ["Bururi", "Songa"] },
      { state: "Cankuzo", cities: ["Cankuzo", "Gisagara"] },
      { state: "Cibitoke", cities: ["Cibitoke", "Buganda"] },
      { state: "Gitega", cities: ["Gitega", "Mutaho"] },
      { state: "Karuzi", cities: ["Karuzi", "Bugenyuzi"] },
      { state: "Kayanza", cities: ["Kayanza", "Matongo"] },
      { state: "Kirundo", cities: ["Kirundo", "Busoni"] },
      { state: "Makamba", cities: ["Makamba", "Nyanza-Lac"] },
      { state: "Muramvya", cities: ["Muramvya", "Bukeye"] },
      { state: "Muyinga", cities: ["Muyinga", "Gasorwe"] },
      { state: "Mwaro", cities: ["Mwaro", "Kayokwe"] },
      { state: "Ngozi", cities: ["Ngozi", "Gashikanwa"] },
      { state: "Rumonge", cities: ["Rumonge", "Burambi"] },
      { state: "Rutana", cities: ["Rutana", "Giharo"] },
      { state: "Ruyigi", cities: ["Ruyigi", "Gisuru"] },
    ],
  },
  {
    country: "Cabo Verde",
    states: [
      { state: "Boa Vista", cities: ["Sal Rei", "Rabil"] },
      { state: "Brava", cities: ["Nova Sintra", "Furna"] },
      { state: "Maio", cities: ["Vila do Maio", "Porto Inglês"] },
      { state: "Sal", cities: ["Espargos", "Santa Maria"] },
      { state: "Santa Catarina", cities: ["Assomada", "Tarrafal"] },
      { state: "Santa Cruz", cities: ["Pedra Badejo", "Santa Cruz"] },
      { state: "São Domingos", cities: ["São Domingos", "Rui Vaz"] },
      { state: "São Filipe", cities: ["São Filipe", "Cova Figueira"] },
      { state: "São Miguel", cities: ["Calheta de São Miguel", "Espinho Branco"] },
      { state: "São Nicolau", cities: ["Ribeira Brava", "Tarrafal de São Nicolau"] },
      { state: "São Vicente", cities: ["Mindelo", "Porto Novo"] },
      { state: "Santiago", cities: ["Praia", "Cidade Velha"] },
      { state: "Santo Antão", cities: ["Porto Novo", "Ribeira Grande"] },
      { state: "Fogo", cities: ["São Filipe", "Mosteiros"] },
    ],
  },
  {
    country: "Cambodia",
    states: [
      { state: "Banteay Meanchey", cities: ["Sisophon", "Poipet", "Serei Saophoan"] },
      { state: "Battambang", cities: ["Battambang", "Banan", "Thma Koul"] },
      { state: "Kampong Cham", cities: ["Kampong Cham", "Suong", "Prey Totung"] },
      { state: "Kampong Chhnang", cities: ["Kampong Chhnang", "Rolea B'ier"] },
      { state: "Kampong Speu", cities: ["Chbar Mon", "Kampong Speu"] },
      { state: "Kampong Thom", cities: ["Kampong Thom", "Stoung", "Baray"] },
      { state: "Kampot", cities: ["Kampot", "Chhuk", "Kampong Trach"] },
      { state: "Kandal", cities: ["Ta Khmau", "Kandal Stueng", "Angk Snuol"] },
      { state: "Kep", cities: ["Kep", "Damnak Chang'aeur"] },
      { state: "Koh Kong", cities: ["Koh Kong", "Khemarak Phoumin"] },
      { state: "Kratié", cities: ["Kratié", "Snuol", "Chhloung"] },
      { state: "Mondulkiri", cities: ["Senmonorom", "Kaev Seima"] },
      { state: "Oddar Meanchey", cities: ["Samraong", "Anlong Veng"] },
      { state: "Pailin", cities: ["Pailin", "Sala Krau"] },
      { state: "Phnom Penh", cities: ["Phnom Penh", "Doun Penh"] },
      { state: "Preah Sihanouk", cities: ["Sihanoukville", "Prey Nob"] },
      { state: "Preah Vihear", cities: ["Tbaeng Meanchey", "Chey Saen"] },
      { state: "Prey Veng", cities: ["Prey Veng", "Kampong Leav"] },
      { state: "Pursat", cities: ["Pursat", "Sampov Meas"] },
      { state: "Ratanakiri", cities: ["Banlung", "Lumphat"] },
      { state: "Siem Reap", cities: ["Siem Reap", "Angkor Chum"] },
      { state: "Stung Treng", cities: ["Stung Treng", "Siem Pang"] },
      { state: "Svay Rieng", cities: ["Svay Rieng", "Chantrea"] },
      { state: "Takeo", cities: ["Doun Kaev", "Bati"] },
    ],
  },
  // Placeholder for remaining countries to be expanded similarly
  {
    country: "Cameroon",
    states: [
      { state: "Adamawa", cities: ["Ngaoundéré", "Tibati", "Tignère", "Meiganga"] },
      { state: "Centre", cities: ["Yaoundé", "Mbalmayo", "Ntui", "Bafia"] },
      { state: "East", cities: ["Bertoua", "Abong-Mbang", "Batouri", "Yokadouma"] },
      { state: "Far North", cities: ["Maroua", "Kousséri", "Mokolo", "Yagoua"] },
      { state: "Littoral", cities: ["Douala", "Edéa", "Nkongsamba", "Loum"] },
      { state: "North", cities: ["Garoua", "Poli", "Tcholliré", "Guider"] },
      { state: "Northwest", cities: ["Bamenda", "Kumbo", "Wum", "Fundong"] },
      { state: "South", cities: ["Ebolowa", "Kribi", "Sangmélima", "Ambam"] },
      { state: "Southwest", cities: ["Buea", "Limbe", "Kumba", "Mamfe"] },
      { state: "West", cities: ["Bafoussam", "Dschang", "Mbouda", "Foumban"] },
    ],
  },
  {
    country: "Canada",
    states: [
      { state: "Alberta", cities: ["Calgary", "Edmonton", "Red Deer", "Lethbridge"] },
      { state: "British Columbia", cities: ["Vancouver", "Victoria", "Kelowna", "Surrey"] },
      { state: "Manitoba", cities: ["Winnipeg", "Brandon", "Thompson", "Portage la Prairie"] },
      { state: "New Brunswick", cities: ["Fredericton", "Moncton", "Saint John", "Dieppe"] },
      { state: "Newfoundland and Labrador", cities: ["St. John's", "Corner Brook", "Mount Pearl", "Conception Bay South"] },
      { state: "Nova Scotia", cities: ["Halifax", "Dartmouth", "Sydney", "Truro"] },
      { state: "Ontario", cities: ["Toronto", "Ottawa", "Mississauga", "Brampton"] },
      { state: "Prince Edward Island", cities: ["Charlottetown", "Summerside", "Stratford"] },
      { state: "Quebec", cities: ["Montreal", "Quebec City", "Laval", "Gatineau"] },
      { state: "Saskatchewan", cities: ["Saskatoon", "Regina", "Prince Albert", "Moose Jaw"] },
      { state: "Yukon", cities: ["Whitehorse", "Dawson City"] },
      { state: "Northwest Territories", cities: ["Yellowknife", "Inuvik", "Hay River"] },
      { state: "Nunavut", cities: ["Iqaluit", "Rankin Inlet", "Arviat"] },
    ],
  },
  {
    country: "Central African Republic",
    states: [
      { state: "Bamingui-Bangoran", cities: ["Ndélé", "Man"] },
      { state: "Bangui", cities: ["Bangui"] },
      { state: "Basse-Kotto", cities: ["Mobaye", "Kembe", "Alindao"] },
      { state: "Haut-Mbomou", cities: ["Obo", "Zemio"] },
      { state: "Haute-Kotto", cities: ["Bria", "Ouadda", "Yalinga"] },
      { state: "Kémo", cities: ["Sibut", "Dekoa"] },
      { state: "Lobaye", cities: ["Mbaïki", "Boda", "Nola"] },
      { state: "Mambéré-Kadéï", cities: ["Berbérati", "Carnot", "Gamboula"] },
      { state: "Mbomou", cities: ["Bangassou", "Gambo", "Ouango"] },
      { state: "Nana-Grébizi", cities: ["Kaga-Bandoro"] },
      { state: "Nana-Mambéré", cities: ["Bouar", "Baboua"] },
      { state: "Ombella-M'Poko", cities: ["Bimbo", "Boali"] },
      { state: "Ouaka", cities: ["Bambari", "Grimari", "Ippy"] },
      { state: "Ouham", cities: ["Bossangoa", "Batangafo", "Bouca"] },
      { state: "Ouham-Pendé", cities: ["Paoua", "Bozoum"] },
      { state: "Sangha-Mbaéré", cities: ["Nola"] },
      { state: "Vakaga", cities: ["Birao"] },
    ],
  },
  {
    country: "Chad",
    states: [
      { state: "Batha", cities: ["Ati", "Oum Hadjer"] },
      { state: "Borkou", cities: ["Faya-Largeau"] },
      { state: "Chari-Baguirmi", cities: ["Massakory", "Bokoro", "Massaguet"] },
      { state: "Ennedi-Est", cities: ["Am-Djarass"] },
      { state: "Ennedi-Ouest", cities: ["Fada"] },
      { state: "Guéra", cities: ["Mongo", "Bitkine"] },
      { state: "Hadjer-Lamis", cities: ["Massakory", "Bokoro"] },
      { state: "Kanem", cities: ["Mao", "Nokou"] },
      { state: "Lac", cities: ["Bol", "Ngouri"] },
      { state: "Logone Occidental", cities: ["Moundou", "Beinamar"] },
      { state: "Logone Oriental", cities: ["Doba", "Goré"] },
      { state: "Mandoul", cities: ["Koumra", "Moïssala"] },
      { state: "Mayo-Kebbi Est", cities: ["Bongor", "Fianga"] },
      { state: "Mayo-Kebbi Ouest", cities: ["Pala", "Léré"] },
      { state: "Moyen-Chari", cities: ["Sarh", "Kyabé"] },
      { state: "N'Djamena", cities: ["N'Djamena"] },
      { state: "Ouaddaï", cities: ["Abéché", "Adré"] },
      { state: "Salamat", cities: ["Am Timan"] },
      { state: "Sila", cities: ["Goz Beïda"] },
      { state: "Tandjilé", cities: ["Laï", "Kélo"] },
      { state: "Tibesti", cities: ["Bardaï"] },
      { state: "Wadi Fira", cities: ["Biltine", "Iriba"] },
    ],
  },
  {
    country: "Chile",
    states: [
      { state: "Aisén", cities: ["Coyhaique", "Puerto Aysén", "Chile Chico"] },
      { state: "Antofagasta", cities: ["Antofagasta", "Calama", "Tocopilla"] },
      { state: "Araucanía", cities: ["Temuco", "Angol", "Victoria"] },
      { state: "Arica y Parinacota", cities: ["Arica", "Putre"] },
      { state: "Atacama", cities: ["Copiapó", "Vallenar", "Caldera"] },
      { state: "Biobío", cities: ["Concepción", "Los Ángeles", "Talcahuano"] },
      { state: "Coquimbo", cities: ["La Serena", "Coquimbo", "Ovalle"] },
      { state: "Los Lagos", cities: ["Puerto Montt", "Osorno", "Castro"] },
      { state: "Los Ríos", cities: ["Valdivia", "La Unión", "Río Bueno"] },
      { state: "Magallanes", cities: ["Punta Arenas", "Puerto Natales"] },
      { state: "Maule", cities: ["Talca", "Curicó", "Linares"] },
      { state: "Ñuble", cities: ["Chillán", "San Carlos", "Coelemu"] },
      { state: "O'Higgins", cities: ["Rancagua", "San Fernando", "Rengo"] },
      { state: "Santiago Metropolitan", cities: ["Santiago", "Puente Alto", "Maipú"] },
      { state: "Tarapacá", cities: ["Iquique", "Alto Hospicio"] },
      { state: "Valparaíso", cities: ["Valparaíso", "Viña del Mar", "Quilpué"] },
    ],
  },
  {
    country: "China",
    states: [
      { state: "Anhui", cities: ["Hefei", "Wuhu", "Anqing", "Bengbu"] },
      { state: "Beijing", cities: ["Beijing"] },
      { state: "Chongqing", cities: ["Chongqing"] },
      { state: "Fujian", cities: ["Fuzhou", "Xiamen", "Quanzhou", "Zhangzhou"] },
      { state: "Gansu", cities: ["Lanzhou", "Jiayuguan", "Jinchang", "Tianshui"] },
      { state: "Guangdong", cities: ["Guangzhou", "Shenzhen", "Dongguan", "Foshan"] },
      { state: "Guangxi", cities: ["Nanning", "Liuzhou", "Guilin", "Beihai"] },
      { state: "Guizhou", cities: ["Guiyang", "Zunyi", "Anshun", "Bijie"] },
      { state: "Hainan", cities: ["Haikou", "Sanya", "Qionghai"] },
      { state: "Hebei", cities: ["Shijiazhuang", "Tangshan", "Handan", "Baoding"] },
      { state: "Heilongjiang", cities: ["Harbin", "Qiqihar", "Daqing", "Mudanjiang"] },
      { state: "Henan", cities: ["Zhengzhou", "Luoyang", "Nanyang", "Xinxiang"] },
      { state: "Hubei", cities: ["Wuhan", "Yichang", "Xiangyang", "Jingzhou"] },
      { state: "Hunan", cities: ["Changsha", "Zhuzhou", "Xiangtan", "Hengyang"] },
      { state: "Inner Mongolia", cities: ["Hohhot", "Baotou", "Ordos", "Chifeng"] },
      { state: "Jiangsu", cities: ["Nanjing", "Suzhou", "Wuxi", "Changzhou"] },
      { state: "Jiangxi", cities: ["Nanchang", "Jiujiang", "Ganzhou", "Yingtan"] },
      { state: "Jilin", cities: ["Changchun", "Jilin City", "Siping", "Liaoyuan"] },
      { state: "Liaoning", cities: ["Shenyang", "Dalian", "Anshan", "Fushun"] },
      { state: "Ningxia", cities: ["Yinchuan", "Shizuishan", "Wuzhong"] },
      { state: "Qinghai", cities: ["Xining", "Golmud", "Yushu"] },
      { state: "Shaanxi", cities: ["Xi'an", "Baoji", "Xianyang", "Weinan"] },
      { state: "Shandong", cities: ["Jinan", "Qingdao", "Yantai", "Weifang"] },
      { state: "Shanghai", cities: ["Shanghai"] },
      { state: "Shanxi", cities: ["Taiyuan", "Datong", "Changzhi", "Yangquan"] },
      { state: "Sichuan", cities: ["Chengdu", "Mianyang", "Nanchong", "Deyang"] },
      { state: "Tianjin", cities: ["Tianjin"] },
      { state: "Tibet", cities: ["Lhasa", "Shigatse"] },
      { state: "Xinjiang", cities: ["Ürümqi", "Karamay", "Kashgar", "Shihezi"] },
      { state: "Yunnan", cities: ["Kunming", "Qujing", "Yuxi", "Lijiang"] },
      { state: "Zhejiang", cities: ["Hangzhou", "Ningbo", "Wenzhou", "Jiaxing"] },
    ],
  },
  {
    country: "Colombia",
    states: [
      { state: "Amazonas", cities: ["Leticia", "Puerto Nariño"] },
      { state: "Antioquia", cities: ["Medellín", "Bello", "Itagüí", "Envigado"] },
      { state: "Arauca", cities: ["Arauca", "Tame", "Saravena"] },
      { state: "Atlántico", cities: ["Barranquilla", "Soledad", "Malambo"] },
      { state: "Bolívar", cities: ["Cartagena", "Magangué", "Turbaco"] },
      { state: "Boyacá", cities: ["Tunja", "Sogamoso", "Duitama"] },
      { state: "Caldas", cities: ["Manizales", "La Dorada", "Chinchiná"] },
      { state: "Caquetá", cities: ["Florencia", "Cartagena del Chairá"] },
      { state: "Casanare", cities: ["Yopal", "Aguazul", "Villanueva"] },
      { state: "Cauca", cities: ["Popayán", "Santander de Quilichao", "Puerto Tejada"] },
      { state: "Cesar", cities: ["Valledupar", "Aguachica", "Agustín Codazzi"] },
      { state: "Chocó", cities: ["Quibdó", "Istmina", "Condoto"] },
      { state: "Córdoba", cities: ["Montería", "Cereté", "Sahagún"] },
      { state: "Cundinamarca", cities: ["Bogotá", "Soacha", "Zipaquirá", "Girardot"] },
      { state: "Guainía", cities: ["Inírida"] },
      { state: "Guaviare", cities: ["San José del Guaviare"] },
      { state: "Huila", cities: ["Neiva", "Pitalito", "Garzón"] },
      { state: "La Guajira", cities: ["Riohacha", "Maicao", "Uribia"] },
      { state: "Magdalena", cities: ["Santa Marta", "Ciénaga", "Fundación"] },
      { state: "Meta", cities: ["Villavicencio", "Acacías", "Granada"] },
      { state: "Nariño", cities: ["Pasto", "Tumaco", "Ipiales"] },
      { state: "Norte de Santander", cities: ["Cúcuta", "Ocaña", "Pamplona"] },
      { state: "Putumayo", cities: ["Mocoa", "Puerto Asís", "Orito"] },
      { state: "Quindío", cities: ["Armenia", "Calarcá", "Montenegro"] },
      { state: "Risaralda", cities: ["Pereira", "Dosquebradas", "Santa Rosa de Cabal"] },
      { state: "San Andrés y Providencia", cities: ["San Andrés"] },
      { state: "Santander", cities: ["Bucaramanga", "Floridablanca", "Barrancabermeja"] },
      { state: "Sucre", cities: ["Sincelejo", "Corozal", "Sampués"] },
      { state: "Tolima", cities: ["Ibagué", "Espinal", "Melgar"] },
      { state: "Valle del Cauca", cities: ["Cali", "Palmira", "Tuluá", "Buenaventura"] },
      { state: "Vaupés", cities: ["Mitú"] },
      { state: "Vichada", cities: ["Puerto Carreño"] },
    ],
  },
  {
    country: "Comoros",
    states: [
      { state: "Anjouan", cities: ["Mutsamudu", "Domoni", "Ouani"] },
      { state: "Grande Comore", cities: ["Moroni", "Mitsamiouli", "Fomboni"] },
      { state: "Mohéli", cities: ["Fomboni", "Nioumachoua"] },
    ],
  },
  {
    country: "Congo, Democratic Republic of the",
    states: [
      { state: "Bas-Uélé", cities: ["Buta", "Aketi"] },
      { state: "Équateur", cities: ["Mbandaka", "Gemena", "Lisala"] },
      { state: "Haut-Katanga", cities: ["Lubumbashi", "Likasi", "Kolwezi"] },
      { state: "Haut-Lomami", cities: ["Kamina", "Bukama"] },
      { state: "Haut-Uélé", cities: ["Isiro", "Watsa"] },
      { state: "Ituri", cities: ["Bunia", "Aru", "Mahagi"] },
      { state: "Kasaï", cities: ["Tshikapa", "Ilebo"] },
      { state: "Kasaï-Central", cities: ["Kananga", "Demba"] },
      { state: "Kasaï-Oriental", cities: ["Mbuji-Mayi", "Kabeya-Kamwanga"] },
      { state: "Kinshasa", cities: ["Kinshasa"] },
      { state: "Kongo Central", cities: ["Matadi", "Boma", "Moanda"] },
      { state: "Kwango", cities: ["Kenge", "Feshi"] },
      { state: "Kwilu", cities: ["Bandundu", "Idiofa"] },
      { state: "Lomami", cities: ["Kabinda", "Mwene-Ditu"] },
      { state: "Lualaba", cities: ["Kolwezi", "Fungurume"] },
      { state: "Mai-Ndombe", cities: ["Inongo", "Kiri"] },
      { state: "Maniema", cities: ["Kindu", "Kibombo"] },
      { state: "Mongala", cities: ["Lisala", "Bumba"] },
      { state: "Nord-Kivu", cities: ["Goma", "Beni", "Butembo"] },
      { state: "Nord-Ubangi", cities: ["Gbadolite", "Mobayi-Mbongo"] },
      { state: "Sankuru", cities: ["Lusambo", "Lodja"] },
      { state: "Sud-Kivu", cities: ["Bukavu", "Uvira", "Kabare"] },
      { state: "Sud-Ubangi", cities: ["Gemena", "Zongo"] },
      { state: "Tanganyika", cities: ["Kalemie", "Manono"] },
      { state: "Tshopo", cities: ["Kisangani", "Yangambi"] },
      { state: "Tshuapa", cities: ["Boende", "Ikela"] },
    ],
  },
  {
    country: "Congo, Republic of the",
    states: [
      { state: "Bouenza", cities: ["Madingou", "Nkayi"] },
      { state: "Brazzaville", cities: ["Brazzaville"] },
      { state: "Cuvette", cities: ["Owando", "Makoua"] },
      { state: "Cuvette-Ouest", cities: ["Ewo"] },
      { state: "Kouilou", cities: ["Pointe-Noire", "Loango"] },
      { state: "Lékoumou", cities: ["Sibiti", "Komono"] },
      { state: "Likouala", cities: ["Impfondo", "Dongou"] },
      { state: "Niari", cities: ["Dolisie", "Mossendjo"] },
      { state: "Plateaux", cities: ["Djambala", "Gamboma"] },
      { state: "Pool", cities: ["Kinkala", "Kindamba"] },
      { state: "Sangha", cities: ["Ouesso", "Souanké"] },
    ],
  },
  {
    country: "Costa Rica",
    states: [
      { state: "Alajuela", cities: ["Alajuela", "Quesada", "San Ramón", "Grecia"] },
      { state: "Cartago", cities: ["Cartago", "Paraíso", "Turrialba", "La Unión"] },
      { state: "Guanacaste", cities: ["Liberia", "Nicoya", "Santa Cruz", "Tamarindo"] },
      { state: "Heredia", cities: ["Heredia", "Barva", "San Isidro", "San Rafael"] },
      { state: "Limón", cities: ["Limón", "Guápiles", "Siquirres", "Puerto Viejo"] },
      { state: "Puntarenas", cities: ["Puntarenas", "Chacarita", "Quepos", "Jacó"] },
      { state: "San José", cities: ["San José", "Escazú", "Desamparados", "Curridabat"] },
    ],
  },
  {
    country: "Cote d'Ivoire",
    states: [
      { state: "Abidjan", cities: ["Abidjan", "Cocody", "Yopougon", "Treichville"] },
      { state: "Bas-Sassandra", cities: ["San-Pédro", "Sassandra", "Tabou"] },
      { state: "Comoé", cities: ["Abengourou", "Aboisso", "Grand-Bassam"] },
      { state: "Denguélé", cities: ["Odienné", "Madinani"] },
      { state: "Gôh-Djiboua", cities: ["Gagnoa", "Divo", "Lakota"] },
      { state: "Lacs", cities: ["Yamoussoukro", "Dimbokro", "Toumodi"] },
      { state: "Lagunes", cities: ["Dabou", "Jacqueville", "Grand-Lahou"] },
      { state: "Montagnes", cities: ["Man", "Danané", "Bangolo"] },
      { state: "Sassandra-Marahoué", cities: ["Daloa", "Issia", "Vavoua"] },
      { state: "Savanes", cities: ["Korhogo", "Ferkessédougou", "Boundiali"] },
      { state: "Vallée du Bandama", cities: ["Bouaké", "Katiola", "Béoumi"] },
      { state: "Woroba", cities: ["Séguéla", "Mankono", "Touba"] },
      { state: "Zanzan", cities: ["Bondoukou", "Bouna", "Tanda"] },
    ],
  },
  {
    country: "Croatia",
    states: [
      { state: "Bjelovar-Bilogora", cities: ["Bjelovar", "Daruvar", "Čazma"] },
      { state: "Brod-Posavina", cities: ["Slavonski Brod", "Nova Gradiška"] },
      { state: "Dubrovnik-Neretva", cities: ["Dubrovnik", "Metković", "Ploče"] },
      { state: "Istria", cities: ["Pula", "Poreč", "Rovinj", "Labin"] },
      { state: "Karlovac", cities: ["Karlovac", "Ogulin", "Slunj"] },
      { state: "Koprivnica-Križevci", cities: ["Koprivnica", "Križevci", "Đurđevac"] },
      { state: "Krapina-Zagorje", cities: ["Krapina", "Zabok", "Pregrada"] },
      { state: "Lika-Senj", cities: ["Gospić", "Senj", "Otočac"] },
      { state: "Međimurje", cities: ["Čakovec", "Prelog", "Mursko Središće"] },
      { state: "Osijek-Baranja", cities: ["Osijek", "Đakovo", "Našice"] },
      { state: "Požega-Slavonia", cities: ["Požega", "Pleternica", "Kutjevo"] },
      { state: "Primorje-Gorski Kotar", cities: ["Rijeka", "Opatija", "Crikvenica"] },
      { state: "Šibenik-Knin", cities: ["Šibenik", "Knin", "Drniš"] },
      { state: "Sisak-Moslavina", cities: ["Sisak", "Petrinja", "Kutina"] },
      { state: "Split-Dalmatia", cities: ["Split", "Trogir", "Makarska", "Solin"] },
      { state: "Varaždin", cities: ["Varaždin", "Ivanec", "Novi Marof"] },
      { state: "Virovitica-Podravina", cities: ["Virovitica", "Slatina", "Orahovica"] },
      { state: "Vukovar-Syrmia", cities: ["Vukovar", "Vinkovci", "Ilok"] },
      { state: "Zadar", cities: ["Zadar", "Biograd na Moru", "Nin"] },
      { state: "Zagreb", cities: ["Zagreb", "Velika Gorica", "Samobor"] },
      { state: "Zagreb City", cities: ["Zagreb"] },
    ],
  },
  {
    country: "Cuba",
    states: [
      { state: "Artemisa", cities: ["Artemisa", "Guanajay", "San Antonio de los Baños"] },
      { state: "Camagüey", cities: ["Camagüey", "Florida", "Nuevitas"] },
      { state: "Ciego de Ávila", cities: ["Ciego de Ávila", "Morón", "Chambas"] },
      { state: "Cienfuegos", cities: ["Cienfuegos", "Palmira", "Cruces"] },
      { state: "Granma", cities: ["Bayamo", "Manzanillo", "Jiguaní"] },
      { state: "Guantánamo", cities: ["Guantánamo", "Baracoa", "Maisí"] },
      { state: "Havana", cities: ["Havana", "Regla", "Guanabacoa"] },
      { state: "Holguín", cities: ["Holguín", "Moa", "Banes"] },
      { state: "Isla de la Juventud", cities: ["Nueva Gerona"] },
      { state: "Las Tunas", cities: ["Las Tunas", "Puerto Padre", "Amancio"] },
      { state: "Matanzas", cities: ["Matanzas", "Cárdenas", "Varadero"] },
      { state: "Pinar del Río", cities: ["Pinar del Río", "Consolación del Sur", "Los Palacios"] },
      { state: "Sancti Spíritus", cities: ["Sancti Spíritus", "Trinidad", "Jatibonico"] },
      { state: "Santiago de Cuba", cities: ["Santiago de Cuba", "Palma Soriano", "Contramaestre"] },
      { state: "Villa Clara", cities: ["Santa Clara", "Sagua la Grande", "Placetas"] },
    ],
  },
  {
    country: "Cyprus",
    states: [
      { state: "Famagusta", cities: ["Famagusta", "Paralimni", "Deryneia"] },
      { state: "Kyrenia", cities: ["Kyrenia", "Lapithos", "Karavas"] },
      { state: "Larnaca", cities: ["Larnaca", "Aradippou", "Athienou"] },
      { state: "Limassol", cities: ["Limassol", "Ypsonas", "Agios Athanasios"] },
      { state: "Nicosia", cities: ["Nicosia", "Strovolos", "Lakatamia"] },
      { state: "Paphos", cities: ["Paphos", "Polis", "Peyia"] },
    ],
  },
  {
    country: "Czech Republic",
    states: [
      { state: "Central Bohemian", cities: ["Kladno", "Mladá Boleslav", "Příbram"] },
      { state: "Hradec Králové", cities: ["Hradec Králové", "Trutnov", "Náchod"] },
      { state: "Karlovy Vary", cities: ["Karlovy Vary", "Cheb", "Sokolov"] },
      { state: "Liberec", cities: ["Liberec", "Jablonec nad Nisou", "Česká Lípa"] },
      { state: "Moravian-Silesian", cities: ["Ostrava", "Havířov", "Opava"] },
      { state: "Olomouc", cities: ["Olomouc", "Prostějov", "Přerov"] },
      { state: "Pardubice", cities: ["Pardubice", "Chrudim", "Svitavy"] },
      { state: "Plzeň", cities: ["Plzeň", "Klatovy", "Rokycany"] },
      { state: "Prague", cities: ["Prague"] },
      { state: "South Bohemian", cities: ["České Budějovice", "Tábor", "Písek"] },
      { state: "South Moravian", cities: ["Brno", "Znojmo", "Břeclav"] },
      { state: "Ústí nad Labem", cities: ["Ústí nad Labem", "Děčín", "Teplice"] },
      { state: "Vysočina", cities: ["Jihlava", "Havlíčkův Brod", "Třebíč"] },
      { state: "Zlín", cities: ["Zlín", "Kroměříž", "Vsetín"] },
    ],
  },
  {
    country: "Denmark",
    states: [
      { state: "Capital Region", cities: ["Copenhagen", "Frederiksberg", "Hvidovre"] },
      { state: "Central Denmark", cities: ["Aarhus", "Randers", "Horsens"] },
      { state: "North Denmark", cities: ["Aalborg", "Hjørring", "Frederikshavn"] },
      { state: "Region Zealand", cities: ["Roskilde", "Køge", "Næstved"] },
      { state: "Southern Denmark", cities: ["Odense", "Esbjerg", "Kolding"] },
    ],
  },
  {
    country: "Djibouti",
    states: [
      { state: "Ali Sabieh", cities: ["Ali Sabieh", "Holhol"] },
      { state: "Arta", cities: ["Arta"] },
      { state: "Dikhil", cities: ["Dikhil", "Yoboki"] },
      { state: "Djibouti", cities: ["Djibouti City", "Balbala"] },
      { state: "Obock", cities: ["Obock"] },
      { state: "Tadjourah", cities: ["Tadjourah", "Randa"] },
    ],
  },
  {
    country: "Dominica",
    states: [
      { state: "Saint Andrew", cities: ["Marigot", "Wesley"] },
      { state: "Saint David", cities: ["Rosalie", "Castle Bruce"] },
      { state: "Saint George", cities: ["Roseau"] },
      { state: "Saint John", cities: ["Portsmouth"] },
      { state: "Saint Joseph", cities: ["Saint Joseph", "Salisbury"] },
      { state: "Saint Luke", cities: ["Pointe Michel"] },
      { state: "Saint Mark", cities: ["Soufrière"] },
      { state: "Saint Patrick", cities: ["Berekua", "La Plaine"] },
      { state: "Saint Paul", cities: ["Pont Cassé"] },
      { state: "Saint Peter", cities: ["Colihaut"] },
    ],
  },
  {
    country: "Dominican Republic",
    states: [
      { state: "Azua", cities: ["Azua", "Padre Las Casas"] },
      { state: "Baoruco", cities: ["Neiba", "Tamayo"] },
      { state: "Barahona", cities: ["Barahona", "Cabral", "Enriquillo"] },
      { state: "Dajabón", cities: ["Dajabón", "Loma de Cabrera"] },
      { state: "Distrito Nacional", cities: ["Santo Domingo"] },
      { state: "Duarte", cities: ["San Francisco de Macorís", "Pimentel"] },
      { state: "El Seibo", cities: ["El Seibo", "Miches"] },
      { state: "Espaillat", cities: ["Moca", "Gaspar Hernández"] },
      { state: "Hato Mayor", cities: ["Hato Mayor", "Sabana de la Mar"] },
      { state: "La Altagracia", cities: ["Higüey", "Bávaro"] },
      { state: "La Romana", cities: ["La Romana", "Guaymate"] },
      { state: "La Vega", cities: ["La Vega", "Jarabacoa", "Constanza"] },
      { state: "María Trinidad Sánchez", cities: ["Nagua", "Río San Juan"] },
      { state: "Monseñor Nouel", cities: ["Bonao", "Maimón"] },
      { state: "Monte Cristi", cities: ["San Fernando de Monte Cristi", "Villa Vásquez"] },
      { state: "Monte Plata", cities: ["Monte Plata", "Bayaguana"] },
      { state: "Pedernales", cities: ["Pedernales", "Oviedo"] },
      { state: "Peravia", cities: ["Baní", "Nizao"] },
      { state: "Puerto Plata", cities: ["Puerto Plata", "Sosúa", "Imbert"] },
      { state: "Samaná", cities: ["Samaná", "Sánchez"] },
      { state: "San Cristóbal", cities: ["San Cristóbal", "Bajos de Haina"] },
      { state: "San José de Ocoa", cities: ["San José de Ocoa", "Sabana Larga"] },
      { state: "San Juan", cities: ["San Juan de la Maguana", "Las Matas de Farfán"] },
      { state: "San Pedro de Macorís", cities: ["San Pedro de Macorís", "Consuelo"] },
      { state: "Sánchez Ramírez", cities: ["Cotuí", "Cevicos"] },
      { state: "Santiago", cities: ["Santiago de los Caballeros", "Tamboril", "Villa Bisonó"] },
      { state: "Santo Domingo", cities: ["Santo Domingo Este", "Santo Domingo Oeste", "Santo Domingo Norte"] },
      { state: "Valverde", cities: ["Mao", "Esperanza", "Laguna Salada"] },
    ],
  },
  {
    country: "East Timor (Timor-Leste)",
    states: [
      { state: "Aileu", cities: ["Aileu", "Laulara"] },
      { state: "Ainaro", cities: ["Ainaro", "Hato-Udo"] },
      { state: "Baucau", cities: ["Baucau", "Vemasse", "Laga"] },
      { state: "Bobonaro", cities: ["Maliana", "Atabae"] },
      { state: "Cova Lima", cities: ["Suai", "Tilomar"] },
      { state: "Dili", cities: ["Dili", "Atauro"] },
      { state: "Ermera", cities: ["Gleno", "Hatulia"] },
      { state: "Lautém", cities: ["Lospalos", "Luro"] },
      { state: "Liquiçá", cities: ["Liquiçá", "Maubara"] },
      { state: "Manatuto", cities: ["Manatuto", "Laclubar"] },
      { state: "Manufahi", cities: ["Same", "Alas"] },
      { state: "Viqueque", cities: ["Viqueque", "Ossu"] },
    ],
  },
  {
    country: "Ecuador",
    states: [
      { state: "Azuay", cities: ["Cuenca", "Gualaceo", "Paute"] },
      { state: "Bolívar", cities: ["Guaranda", "San Miguel"] },
      { state: "Cañar", cities: ["Azogues", "La Troncal"] },
      { state: "Carchi", cities: ["Tulcán", "San Gabriel"] },
      { state: "Chimborazo", cities: ["Riobamba", "Guano", "Alausí"] },
      { state: "Cotopaxi", cities: ["Latacunga", "La Maná", "Pujilí"] },
      { state: "El Oro", cities: ["Machala", "Santa Rosa", "Piñas"] },
      { state: "Esmeraldas", cities: ["Esmeraldas", "San Lorenzo", "Muisne"] },
      { state: "Galápagos", cities: ["Puerto Baquerizo Moreno", "Puerto Ayora"] },
      { state: "Guayas", cities: ["Guayaquil", "Durán", "Milagro", "Daule"] },
      { state: "Imbabura", cities: ["Ibarra", "Otavalo", "Atuntaqui"] },
      { state: "Loja", cities: ["Loja", "Catamayo", "Cariamanga"] },
      { state: "Los Ríos", cities: ["Babahoyo", "Quevedo", "Ventanas"] },
      { state: "Manabí", cities: ["Portoviejo", "Manta", "Chone", "Bahía de Caráquez"] },
      { state: "Morona-Santiago", cities: ["Macas", "Gualaquiza"] },
      { state: "Napo", cities: ["Tena", "Archidona"] },
      { state: "Orellana", cities: ["Puerto Francisco de Orellana", "Joya de los Sachas"] },
      { state: "Pastaza", cities: ["Puyo", "Mera"] },
      { state: "Pichincha", cities: ["Quito", "Cayambe", "Sangolquí"] },
      { state: "Santa Elena", cities: ["Santa Elena", "La Libertad", "Salinas"] },
      { state: "Santo Domingo de los Tsáchilas", cities: ["Santo Domingo", "La Concordia"] },
      { state: "Sucumbíos", cities: ["Nueva Loja", "Shushufindi"] },
      { state: "Tungurahua", cities: ["Ambato", "Pelileo", "Baños"] },
      { state: "Zamora-Chinchipe", cities: ["Zamora", "Yantzaza"] },
    ],
  },
  {
    country: "Egypt",
    states: [
      { state: "Alexandria", cities: ["Alexandria", "Borg El Arab", "New Borg El Arab"] },
      { state: "Aswan", cities: ["Aswan", "Kom Ombo", "Edfu"] },
      { state: "Asyut", cities: ["Asyut", "Abnub", "Manfalut"] },
      { state: "Beheira", cities: ["Damanhur", "Kafr El Dawwar", "Rosetta"] },
      { state: "Beni Suef", cities: ["Beni Suef", "Nasser", "Beba"] },
      { state: "Cairo", cities: ["Cairo", "Giza", "Nasr City", "Heliopolis"] },
      { state: "Dakahlia", cities: ["Mansoura", "Mit Ghamr", "Talkha"] },
      { state: "Damietta", cities: ["Damietta", "Faraskur", "Kafr Saad"] },
      { state: "Faiyum", cities: ["Faiyum", "Tamiya", "Sinnuris"] },
      { state: "Gharbia", cities: ["Tanta", "Mahalla El Kubra", "Kafr El Zayat"] },
      { state: "Ismailia", cities: ["Ismailia", "Fayed", "Qantara Sharq"] },
      { state: "Kafr El Sheikh", cities: ["Kafr El Sheikh", "Desouk", "Fuwwah"] },
      { state: "Luxor", cities: ["Luxor", "Esna", "Armant"] },
      { state: "Matrouh", cities: ["Marsa Matrouh", "El Hamam", "Sidi Barrani"] },
      { state: "Minya", cities: ["Minya", "Mallawi", "Samalut"] },
      { state: "Monufia", cities: ["Shibin El Kom", "Menouf", "Ashmun"] },
      { state: "New Valley", cities: ["Kharga", "Dakhla", "Farafra"] },
      { state: "North Sinai", cities: ["Arish", "Sheikh Zuweid", "Rafah"] },
      { state: "Port Said", cities: ["Port Said", "Port Fuad"] },
      { state: "Qalyubia", cities: ["Banha", "Qalyub", "Shubra El Kheima"] },
      { state: "Qena", cities: ["Qena", "Nag Hammadi", "Dishna"] },
      { state: "Red Sea", cities: ["Hurghada", "Safaga", "Marsa Alam"] },
      { state: "Sharqia", cities: ["Zagazig", "Bilbeis", "10th of Ramadan"] },
      { state: "Sohag", cities: ["Sohag", "Girga", "Akhmim"] },
      { state: "South Sinai", cities: ["Sharm El Sheikh", "Dahab", "Nuweiba"] },
      { state: "Suez", cities: ["Suez", "Arbaeen", "Attaka"] },
    ],
  },
  {
    country: "El Salvador",
    states: [
      { state: "Ahuachapán", cities: ["Ahuachapán", "Atiquizaya", "Tacuba"] },
      { state: "Cabañas", cities: ["Sensuntepeque", "Ilobasco"] },
      { state: "Chalatenango", cities: ["Chalatenango", "Nueva Concepción"] },
      { state: "Cuscatlán", cities: ["Cojutepeque", "Suchitoto"] },
      { state: "La Libertad", cities: ["Santa Tecla", "Antiguo Cuscatlán", "Quezaltepeque"] },
      { state: "La Paz", cities: ["Zacatecoluca", "Santiago Nonualco"] },
      { state: "La Unión", cities: ["La Unión", "Santa Rosa de Lima"] },
      { state: "Morazán", cities: ["San Francisco Gotera", "Corinto"] },
      { state: "San Miguel", cities: ["San Miguel", "Chinameca", "Ciudad Barrios"] },
      { state: "San Salvador", cities: ["San Salvador", "Soyapango", "Mejicanos", "Apopa"] },
      { state: "San Vicente", cities: ["San Vicente", "Apastepeque"] },
      { state: "Santa Ana", cities: ["Santa Ana", "Metapán", "Chalchuapa"] },
      { state: "Sonsonate", cities: ["Sonsonate", "Izalco", "Acajutla"] },
      { state: "Usulután", cities: ["Usulután", "Jiquilisco", "Puerto El Triunfo"] },
    ],
  },
  {
    country: "Equatorial Guinea",
    states: [
      { state: "Annobón", cities: ["San Antonio de Palé"] },
      { state: "Bioko Norte", cities: ["Malabo", "Rebola"] },
      { state: "Bioko Sur", cities: ["Luba", "Riaba"] },
      { state: "Centro Sur", cities: ["Evinayong", "Bicurga"] },
      { state: "Kié-Ntem", cities: ["Ebebiyín", "Niefang"] },
      { state: "Litoral", cities: ["Bata", "Mbini", "Kogo"] },
      { state: "Wele-Nzas", cities: ["Mongomo", "Añisoc", "Nsok"] },
    ],
  },
  {
    country: "Eritrea",
    states: [
      { state: "Anseba", cities: ["Keren", "Hagaz"] },
      { state: "Debub", cities: ["Mendefera", "Adi Keyh", "Dekemhare"] },
      { state: "Gash-Barka", cities: ["Barentu", "Teseney", "Ak'ordat"] },
      { state: "Maekel", cities: ["Asmara"] },
      { state: "Northern Red Sea", cities: ["Massawa", "Nakfa"] },
      { state: "Southern Red Sea", cities: ["Assab", "Edd"] },
    ],
  },
  {
    country: "Estonia",
    states: [
      { state: "Harju", cities: ["Tallinn", "Maardu", "Keila", "Saue"] },
      { state: "Hiiu", cities: ["Kärdla"] },
      { state: "Ida-Viru", cities: ["Narva", "Kohtla-Järve", "Sillamäe"] },
      { state: "Järva", cities: ["Paide", "Türi"] },
      { state: "Jõgeva", cities: ["Jõgeva", "Põltsamaa"] },
      { state: "Lääne", cities: ["Haapsalu"] },
      { state: "Lääne-Viru", cities: ["Rakvere", "Tapa", "Kunda"] },
      { state: "Pärnu", cities: ["Pärnu", "Sindi"] },
      { state: "Põlva", cities: ["Põlva", "Räpina"] },
      { state: "Rapla", cities: ["Rapla", "Kohila"] },
      { state: "Saare", cities: ["Kuressaare"] },
      { state: "Tartu", cities: ["Tartu", "Elva"] },
      { state: "Valga", cities: ["Valga", "Tõrva"] },
      { state: "Viljandi", cities: ["Viljandi", "Mõisaküla"] },
      { state: "Võru", cities: ["Võru", "Antsla"] },
    ],
  },
  {
    country: "Eswatini",
    states: [
      { state: "Hhohho", cities: ["Mbabane", "Pigg's Peak", "Bulembu"] },
      { state: "Lubombo", cities: ["Siteki", "Big Bend", "Tshaneni"] },
      { state: "Manzini", cities: ["Manzini", "Matsapha", "Malkerns"] },
      { state: "Shiselweni", cities: ["Nhlangano", "Hlatikulu"] },
    ],
  },
  {
    country: "Ethiopia",
    states: [
      { state: "Addis Ababa", cities: ["Addis Ababa"] },
      { state: "Afar", cities: ["Semera", "Asaita", "Awash"] },
      { state: "Amhara", cities: ["Bahir Dar", "Gondar", "Dessie", "Debre Markos"] },
      { state: "Benishangul-Gumuz", cities: ["Assosa", "Gilgel Beles"] },
      { state: "Dire Dawa", cities: ["Dire Dawa"] },
      { state: "Gambela", cities: ["Gambela", "Itang"] },
      { state: "Harari", cities: ["Harar"] },
      { state: "Oromia", cities: ["Adama", "Jimma", "Shashamane", "Nekemte"] },
      { state: "Sidama", cities: ["Hawassa", "Yirgalem"] },
      { state: "Somali", cities: ["Jijiga", "Gode", "Kebri Dahar"] },
      { state: "South West Ethiopia Peoples", cities: ["Bonga", "Mizan Teferi"] },
      { state: "Southern Nations, Nationalities, and Peoples", cities: ["Arba Minch", "Sodo", "Dilla"] },
      { state: "Tigray", cities: ["Mekele", "Adigrat", "Shire"] },
    ],
  },
  {
    country: "Fiji",
    states: [
      { state: "Central", cities: ["Suva", "Nausori", "Navua"] },
      { state: "Eastern", cities: ["Levuka", "Lomaloma"] },
      { state: "Northern", cities: ["Labasa", "Savusavu"] },
      { state: "Western", cities: ["Lautoka", "Nadi", "Ba"] },
      { state: "Rotuma", cities: ["Ahau"] },
    ],
  },
  {
    country: "Finland",
    states: [
      { state: "Åland Islands", cities: ["Mariehamn"] },
      { state: "Central Finland", cities: ["Jyväskylä", "Jämsä", "Äänekoski"] },
      { state: "Central Ostrobothnia", cities: ["Kokkola", "Kannus"] },
      { state: "Kainuu", cities: ["Kajaani", "Sotkamo"] },
      { state: "Kymenlaakso", cities: ["Kotka", "Kouvola", "Hamina"] },
      { state: "Lapland", cities: ["Rovaniemi", "Kemi", "Tornio"] },
      { state: "North Karelia", cities: ["Joensuu", "Lieksa", "Kitee"] },
      { state: "Northern Ostrobothnia", cities: ["Oulu", "Raahe", "Kuusamo"] },
      { state: "Northern Savonia", cities: ["Kuopio", "Iisalmi", "Varkaus"] },
      { state: "Ostrobothnia", cities: ["Vaasa", "Jakobstad", "Korsholm"] },
      { state: "Päijät-Häme", cities: ["Lahti", "Hollola", "Orimattila"] },
      { state: "Pirkanmaa", cities: ["Tampere", "Nokia", "Ylöjärvi"] },
      { state: "Satakunta", cities: ["Pori", "Rauma", "Kankaanpää"] },
      { state: "South Karelia", cities: ["Lappeenranta", "Imatra"] },
      { state: "Southern Ostrobothnia", cities: ["Seinäjoki", "Kauhava", "Lapua"] },
      { state: "Southern Savonia", cities: ["Mikkeli", "Savonlinna", "Pieksämäki"] },
      { state: "Southwest Finland", cities: ["Turku", "Salo", "Uusikaupunki"] },
      { state: "Uusimaa", cities: ["Helsinki", "Espoo", "Vantaa", "Porvoo"] },
    ],
  },
  {
    country: "France",
    states: [
      { state: "Auvergne-Rhône-Alpes", cities: ["Lyon", "Grenoble", "Saint-Étienne", "Clermont-Ferrand"] },
      { state: "Bourgogne-Franche-Comté", cities: ["Dijon", "Besançon", "Belfort"] },
      { state: "Brittany", cities: ["Rennes", "Brest", "Quimper"] },
      { state: "Centre-Val de Loire", cities: ["Orléans", "Tours", "Bourges"] },
      { state: "Corsica", cities: ["Ajaccio", "Bastia"] },
      { state: "Grand Est", cities: ["Strasbourg", "Reims", "Metz", "Nancy"] },
      { state: "Hauts-de-France", cities: ["Lille", "Amiens", "Dunkirk"] },
      { state: "Île-de-France", cities: ["Paris", "Versailles", "Boulogne-Billancourt"] },
      { state: "Normandy", cities: ["Rouen", "Caen", "Le Havre"] },
      { state: "Nouvelle-Aquitaine", cities: ["Bordeaux", "Poitiers", "Limoges"] },
      { state: "Occitanie", cities: ["Toulouse", "Montpellier", "Nîmes"] },
      { state: "Pays de la Loire", cities: ["Nantes", "Angers", "Le Mans"] },
      { state: "Provence-Alpes-Côte d'Azur", cities: ["Marseille", "Nice", "Toulon", "Aix-en-Provence"] },
    ],
  },
  {
    country: "Gabon",
    states: [
      { state: "Estuaire", cities: ["Libreville", "Owendo", "Akanda"] },
      { state: "Haut-Ogooué", cities: ["Franceville", "Moanda", "Mounana"] },
      { state: "Moyen-Ogooué", cities: ["Lambaréné", "Ndjolé"] },
      { state: "Ngounié", cities: ["Mouila", "Ndendé"] },
      { state: "Nyanga", cities: ["Tchibanga", "Mayumba"] },
      { state: "Ogooué-Ivindo", cities: ["Makokou", "Booué"] },
      { state: "Ogooué-Lolo", cities: ["Koulamoutou", "Lastoursville"] },
      { state: "Ogooué-Maritime", cities: ["Port-Gentil", "Gamba"] },
      { state: "Woleu-Ntem", cities: ["Oyem", "Bitam", "Mitzic"] },
    ],
  },
  {
    country: "Gambia",
    states: [
      { state: "Banjul", cities: ["Banjul"] },
      { state: "Central River", cities: ["Janjanbureh", "Kuntaur"] },
      { state: "Lower River", cities: ["Mansa Konko", "Soma"] },
      { state: "North Bank", cities: ["Kerewan", "Farafenni"] },
      { state: "Upper River", cities: ["Basse Santa Su", "Sabi"] },
      { state: "West Coast", cities: ["Brikama", "Bakau", "Serekunda"] },
    ],
  },
  {
    country: "Georgia",
    states: [
      { state: "Abkhazia", cities: ["Sukhumi", "Gagra", "Gudauta"] },
      { state: "Adjara", cities: ["Batumi", "Kobuleti", "Khelvachauri"] },
      { state: "Guria", cities: ["Ozurgeti", "Lanchkhuti"] },
      { state: "Imereti", cities: ["Kutaisi", "Zestaponi", "Samtredia"] },
      { state: "Kakheti", cities: ["Telavi", "Gurjaani", "Kvareli"] },
      { state: "Kvemo Kartli", cities: ["Rustavi", "Marneuli", "Gardabani"] },
      { state: "Mtskheta-Mtianeti", cities: ["Mtskheta", "Dusheti"] },
      { state: "Racha-Lechkhumi and Kvemo Svaneti", cities: ["Ambrolauri", "Oni"] },
      { state: "Samegrelo-Zemo Svaneti", cities: ["Zugdidi", "Poti", "Senaki"] },
      { state: "Samtskhe-Javakheti", cities: ["Akhaltsikhe", "Borjomi", "Akhalkalaki"] },
      { state: "Shida Kartli", cities: ["Gori", "Kaspi", "Khashuri"] },
      { state: "Tbilisi", cities: ["Tbilisi"] },
    ],
  },
  {
    country: "Germany",
    states: [
      { state: "Baden-Württemberg", cities: ["Stuttgart", "Karlsruhe", "Mannheim", "Freiburg"] },
      { state: "Bavaria", cities: ["Munich", "Nuremberg", "Augsburg", "Regensburg"] },
      { state: "Berlin", cities: ["Berlin"] },
      { state: "Brandenburg", cities: ["Potsdam", "Cottbus", "Brandenburg an der Havel"] },
      { state: "Bremen", cities: ["Bremen", "Bremerhaven"] },
      { state: "Hamburg", cities: ["Hamburg"] },
      { state: "Hesse", cities: ["Frankfurt", "Wiesbaden", "Darmstadt"] },
      { state: "Lower Saxony", cities: ["Hannover", "Braunschweig", "Oldenburg"] },
      { state: "Mecklenburg-Vorpommern", cities: ["Schwerin", "Rostock", "Stralsund"] },
      { state: "North Rhine-Westphalia", cities: ["Cologne", "Düsseldorf", "Dortmund", "Essen"] },
      { state: "Rhineland-Palatinate", cities: ["Mainz", "Ludwigshafen", "Koblenz"] },
      { state: "Saarland", cities: ["Saarbrücken", "Völklingen"] },
      { state: "Saxony", cities: ["Dresden", "Leipzig", "Chemnitz"] },
      { state: "Saxony-Anhalt", cities: ["Magdeburg", "Halle", "Dessau-Roßlau"] },
      { state: "Schleswig-Holstein", cities: ["Kiel", "Lübeck", "Flensburg"] },
      { state: "Thuringia", cities: ["Erfurt", "Jena", "Gera"] },
    ],
  },
  {
    country: "Ghana",
    states: [
      { state: "Ahafo", cities: ["Goaso", "Kukuom"] },
      { state: "Ashanti", cities: ["Kumasi", "Obuasi", "Mampong"] },
      { state: "Bono", cities: ["Sunyani", "Berekum", "Dormaa Ahenkro"] },
      { state: "Bono East", cities: ["Techiman", "Kintampo", "Atebubu"] },
      { state: "Central", cities: ["Cape Coast", "Winneba", "Kasoa"] },
      { state: "Eastern", cities: ["Koforidua", "Nkawkaw", "Suhum"] },
      { state: "Greater Accra", cities: ["Accra", "Tema", "Madina", "Ashaiman"] },
      { state: "North East", cities: ["Nalerigu", "Walewale"] },
      { state: "Northern", cities: ["Tamale", "Yendi", "Savelugu"] },
      { state: "Oti", cities: ["Dambai", "Kpando"] },
      { state: "Savannah", cities: ["Damongo", "Bole"] },
      { state: "Upper East", cities: ["Bolgatanga", "Bawku", "Navrongo"] },
      { state: "Upper West", cities: ["Wa", "Tumu", "Nandom"] },
      { state: "Volta", cities: ["Ho", "Hohoe", "Keta"] },
      { state: "Western", cities: ["Sekondi-Takoradi", "Tarkwa", "Axim"] },
      { state: "Western North", cities: ["Sefwi Wiawso", "Bibiani"] },
    ],
  },
  {
    country: "Greece",
    states: [
      { state: "Attica", cities: ["Athens", "Piraeus", "Peristeri", "Kallithea"] },
      { state: "Central Greece", cities: ["Lamia", "Chalkida", "Livadeia"] },
      { state: "Central Macedonia", cities: ["Thessaloniki", "Serres", "Katerini"] },
      { state: "Crete", cities: ["Heraklion", "Chania", "Rethymno"] },
      { state: "Eastern Macedonia and Thrace", cities: ["Komotini", "Alexandroupoli", "Kavala"] },
      { state: "Epirus", cities: ["Ioannina", "Arta", "Preveza"] },
      { state: "Ionian Islands", cities: ["Corfu", "Zakynthos", "Kefalonia"] },
      { state: "North Aegean", cities: ["Mytilene", "Chios", "Samos"] },
      { state: "Peloponnese", cities: ["Kalamata", "Corinth", "Tripoli"] },
      { state: "South Aegean", cities: ["Rhodes", "Kos", "Mykonos"] },
      { state: "Thessaly", cities: ["Larissa", "Volos", "Trikala"] },
      { state: "Western Greece", cities: ["Patras", "Agrinio", "Pyrgos"] },
      { state: "Western Macedonia", cities: ["Kozani", "Florina", "Kastoria"] },
    ],
  },
  {
    country: "Grenada",
    states: [
      { state: "Carriacou and Petite Martinique", cities: ["Hillsborough"] },
      { state: "Saint Andrew", cities: ["Grenville"] },
      { state: "Saint David", cities: ["Saint David's"] },
      { state: "Saint George", cities: ["St. George's", "Gouyave"] },
      { state: "Saint John", cities: ["Gouyave"] },
      { state: "Saint Mark", cities: ["Victoria"] },
      { state: "Saint Patrick", cities: ["Sauteurs"] },
    ],
  },
  {
    country: "Guatemala",
    states: [
      { state: "Alta Verapaz", cities: ["Cobán", "San Pedro Carchá"] },
      { state: "Baja Verapaz", cities: ["Salamá", "Rabinal"] },
      { state: "Chimaltenango", cities: ["Chimaltenango", "Tecpán Guatemala"] },
      { state: "Chiquimula", cities: ["Chiquimula", "Esquipulas"] },
      { state: "El Progreso", cities: ["Guastatoya", "Sanarate"] },
      { state: "Escuintla", cities: ["Escuintla", "Santa Lucía Cotzumalguapa"] },
      { state: "Guatemala", cities: ["Guatemala City", "Mixco", "Villa Nueva"] },
      { state: "Huehuetenango", cities: ["Huehuetenango", "Chiantla"] },
      { state: "Izabal", cities: ["Puerto Barrios", "Morales", "Los Amates"] },
      { state: "Jalapa", cities: ["Jalapa", "Monjas"] },
      { state: "Jutiapa", cities: ["Jutiapa", "Asunción Mita"] },
      { state: "Petén", cities: ["Flores", "San Benito", "Santa Elena"] },
      { state: "Quetzaltenango", cities: ["Quetzaltenango", "Coatepeque", "Salcajá"] },
      { state: "Quiché", cities: ["Santa Cruz del Quiché", "Chichicastenango"] },
      { state: "Retalhuleu", cities: ["Retalhuleu", "San Sebastián"] },
      { state: "Sacatepéquez", cities: ["Antigua Guatemala", "Ciudad Vieja"] },
      { state: "San Marcos", cities: ["San Marcos", "San Pedro Sacatepéquez"] },
      { state: "Santa Rosa", cities: ["Cuilapa", "Barberena"] },
      { state: "Sololá", cities: ["Sololá", "Panajachel"] },
      { state: "Suchitepéquez", cities: ["Mazatenango", "Santo Domingo Suchitepéquez"] },
      { state: "Totonicapán", cities: ["Totonicapán", "San Cristóbal Totonicapán"] },
      { state: "Zacapa", cities: ["Zacapa", "Gualán"] },
    ],
  },
  {
    country: "Guinea",
    states: [
      { state: "Boké", cities: ["Boké", "Kamsar", "Sangarédi"] },
      { state: "Conakry", cities: ["Conakry"] },
      { state: "Faranah", cities: ["Faranah", "Kissidougou", "Dabola"] },
      { state: "Kankan", cities: ["Kankan", "Siguiri", "Mandiana"] },
      { state: "Kindia", cities: ["Kindia", "Télimélé", "Coyah"] },
      { state: "Labé", cities: ["Labé", "Pita", "Koubia"] },
      { state: "Mamou", cities: ["Mamou", "Dalaba", "Pita"] },
      { state: "Nzérékoré", cities: ["Nzérékoré", "Macenta", "Gueckedou"] },
    ],
  },
  {
    country: "Guinea-Bissau",
    states: [
      { state: "Bafatá", cities: ["Bafatá", "Contuboel"] },
      { state: "Biombo", cities: ["Quinhámel", "Safim"] },
      { state: "Bissau", cities: ["Bissau"] },
      { state: "Bolama", cities: ["Bolama"] },
      { state: "Cacheu", cities: ["Cacheu", "Canchungo"] },
      { state: "Gabú", cities: ["Gabú", "Boé"] },
      { state: "Oio", cities: ["Farim", "Mansoa"] },
      { state: "Quinara", cities: ["Buba", "Fulacunda"] },
      { state: "Tombali", cities: ["Catió", "Bedanda"] },
    ],
  },
  {
    country: "Guyana",
    states: [
      { state: "Barima-Waini", cities: ["Mabaruma", "Port Kaituma"] },
      { state: "Cuyuni-Mazaruni", cities: ["Bartica"] },
      { state: "Demerara-Mahaica", cities: ["Georgetown", "Linden", "Mahaica"] },
      { state: "East Berbice-Corentyne", cities: ["New Amsterdam", "Corriverton"] },
      { state: "Essequibo Islands-West Demerara", cities: ["Vreed-en-Hoop", "Parika"] },
      { state: "Mahaica-Berbice", cities: ["Fort Wellington", "Rosignol"] },
      { state: "Pomeroon-Supenaam", cities: ["Anna Regina", "Charity"] },
      { state: "Potaro-Siparuni", cities: ["Mahdia"] },
      { state: "Upper Demerara-Berbice", cities: ["Linden", "Ituni"] },
      { state: "Upper Takutu-Upper Essequibo", cities: ["Lethem"] },
    ],
  },
  {
    country: "Haiti",
    states: [
      { state: "Artibonite", cities: ["Gonaïves", "Saint-Marc", "Gros-Morne"] },
      { state: "Centre", cities: ["Hinche", "Mirebalais"] },
      { state: "Grand'Anse", cities: ["Jérémie", "Anse-d'Hainault"] },
      { state: "Nippes", cities: ["Miragoâne", "Anse-à-Veau"] },
      { state: "Nord", cities: ["Cap-Haïtien", "Limbé", "Grande-Rivière-du-Nord"] },
      { state: "Nord-Est", cities: ["Fort-Liberté", "Ouanaminthe"] },
      { state: "Nord-Ouest", cities: ["Port-de-Paix", "Saint-Louis-du-Nord"] },
      { state: "Ouest", cities: ["Port-au-Prince", "Carrefour", "Delmas", "Pétion-Ville"] },
      { state: "Sud", cities: ["Les Cayes", "Aquin", "Chantal"] },
      { state: "Sud-Est", cities: ["Jacmel", "Bainet"] },
    ],
  },
  {
    country: "Honduras",
    states: [
      { state: "Atlántida", cities: ["La Ceiba", "Tela", "Jutiapa"] },
      { state: "Choluteca", cities: ["Choluteca", "San Marcos de Colón"] },
      { state: "Colón", cities: ["Trujillo", "Tocoa", "Sabá"] },
      { state: "Comayagua", cities: ["Comayagua", "Siguatepeque"] },
      { state: "Copán", cities: ["Santa Rosa de Copán", "Copán Ruinas"] },
      { state: "Cortés", cities: ["San Pedro Sula", "Puerto Cortés", "Choloma"] },
      { state: "El Paraíso", cities: ["Yuscarán", "Danlí"] },
      { state: "Francisco Morazán", cities: ["Tegucigalpa", "Comayagüela", "Talanga"] },
      { state: "Gracias a Dios", cities: ["Puerto Lempira"] },
      { state: "Intibucá", cities: ["La Esperanza", "Jesús de Otoro"] },
      { state: "Islas de la Bahía", cities: ["Roatán", "Guanaja"] },
      { state: "La Paz", cities: ["La Paz", "Marcala"] },
      { state: "Lempira", cities: ["Gracias", "Erandique"] },
      { state: "Ocotepeque", cities: ["Ocotepeque", "Sinuapa"] },
      { state: "Olancho", cities: ["Juticalpa", "Catacamas"] },
      { state: "Santa Bárbara", cities: ["Santa Bárbara", "Trinidad"] },
      { state: "Valle", cities: ["Nacaome", "San Lorenzo"] },
      { state: "Yoro", cities: ["Yoro", "El Progreso", "Olanchito"] },
    ],
  },
  {
    country: "Hungary",
    states: [
      { state: "Bács-Kiskun", cities: ["Kecskemét", "Baja", "Kiskunfélegyháza"] },
      { state: "Baranya", cities: ["Pécs", "Komló", "Szigetvár"] },
      { state: "Békés", cities: ["Békéscsaba", "Gyula", "Orosháza"] },
      { state: "Borsod-Abaúj-Zemplén", cities: ["Miskolc", "Ózd", "Kazincbarcika"] },
      { state: "Budapest", cities: ["Budapest"] },
      { state: "Csongrád-Csanád", cities: ["Szeged", "Hódmezővásárhely", "Makó"] },
      { state: "Fejér", cities: ["Székesfehérvár", "Dunaújváros", "Mór"] },
      { state: "Győr-Moson-Sopron", cities: ["Győr", "Sopron", "Mosonmagyaróvár"] },
      { state: "Hajdú-Bihar", cities: ["Debrecen", "Hajdúszoboszló", "Hajdúböszörmény"] },
      { state: "Heves", cities: ["Eger", "Gyöngyös", "Hatvan"] },
      { state: "Jász-Nagykun-Szolnok", cities: ["Szolnok", "Jászberény", "Karcag"] },
      { state: "Komárom-Esztergom", cities: ["Tatabánya", "Esztergom", "Komárom"] },
      { state: "Nógrád", cities: ["Salgótarján", "Balassagyarmat"] },
      { state: "Pest", cities: ["Érd", "Cegléd", "Dunakeszi"] },
      { state: "Somogy", cities: ["Kaposvár", "Siófok", "Marcali"] },
      { state: "Szabolcs-Szatmár-Bereg", cities: ["Nyíregyháza", "Mátészalka", "Kisvárda"] },
      { state: "Tolna", cities: ["Szekszárd", "Paks", "Dombóvár"] },
      { state: "Vas", cities: ["Szombathely", "Kőszeg", "Sárvár"] },
      { state: "Veszprém", cities: ["Veszprém", "Ajka", "Várpalota"] },
      { state: "Zala", cities: ["Zalaegerszeg", "Nagykanizsa", "Keszthely"] },
    ],
  },
  {
    country: "Iceland",
    states: [
      { state: "Capital Region", cities: ["Reykjavík", "Kópavogur", "Hafnarfjörður", "Garðabær"] },
      { state: "Eastern Region", cities: ["Seyðisfjörður", "Egilsstaðir"] },
      { state: "Northeastern Region", cities: ["Akureyri", "Húsavík"] },
      { state: "Northwestern Region", cities: ["Ísafjörður", "Sauðárkrókur"] },
      { state: "Southern Peninsula", cities: ["Keflavík", "Grindavík"] },
      { state: "Southern Region", cities: ["Selfoss", "Vík", "Hella"] },
      { state: "Western Region", cities: ["Akranes", "Borgarnes"] },
      { state: "Westfjords", cities: ["Ísafjörður", "Patreksfjörður"] },
    ],
  },
  {
    country: "Indonesia",
    states: [
      { state: "Aceh", cities: ["Banda Aceh", "Lhokseumawe", "Langsa"] },
      { state: "Bali", cities: ["Denpasar", "Singaraja", "Kuta"] },
      { state: "Banten", cities: ["Serang", "Tangerang", "Cilegon"] },
      { state: "Bengkulu", cities: ["Bengkulu", "Curup"] },
      { state: "Central Java", cities: ["Semarang", "Surakarta", "Purwokerto"] },
      { state: "Central Kalimantan", cities: ["Palangkaraya", "Pangkalan Bun"] },
      { state: "Central Sulawesi", cities: ["Palu", "Poso", "Luwuk"] },
      { state: "East Java", cities: ["Surabaya", "Malang", "Kediri", "Madiun"] },
      { state: "East Kalimantan", cities: ["Samarinda", "Balikpapan", "Bontang"] },
      { state: "East Nusa Tenggara", cities: ["Kupang", "Ende", "Maumere"] },
      { state: "Gorontalo", cities: ["Gorontalo"] },
      { state: "Jakarta", cities: ["Jakarta"] },
      { state: "Jambi", cities: ["Jambi", "Sungai Penuh"] },
      { state: "Lampung", cities: ["Bandar Lampung", "Metro"] },
      { state: "Maluku", cities: ["Ambon", "Tual"] },
      { state: "North Kalimantan", cities: ["Tarakan", "Tanjung Selor"] },
      { state: "North Maluku", cities: ["Ternate", "Tidore"] },
      { state: "North Sulawesi", cities: ["Manado", "Bitung", "Tomohon"] },
      { state: "North Sumatra", cities: ["Medan", "Pematang Siantar", "Binjai"] },
      { state: "Papua", cities: ["Jayapura", "Merauke"] },
      { state: "Riau", cities: ["Pekanbaru", "Dumai"] },
      { state: "Riau Islands", cities: ["Tanjung Pinang", "Batam"] },
      { state: "South Kalimantan", cities: ["Banjarmasin", "Banjarbaru"] },
      { state: "South Sulawesi", cities: ["Makassar", "Parepare", "Palopo"] },
      { state: "South Sumatra", cities: ["Palembang", "Lubuklinggau", "Prabumulih"] },
      { state: "Southeast Sulawesi", cities: ["Kendari", "Bau-Bau"] },
      { state: "West Java", cities: ["Bandung", "Bogor", "Bekasi", "Depok"] },
      { state: "West Kalimantan", cities: ["Pontianak", "Singkawang"] },
      { state: "West Nusa Tenggara", cities: ["Mataram", "Bima"] },
      { state: "West Papua", cities: ["Manokwari", "Sorong"] },
      { state: "West Sulawesi", cities: ["Mamuju"] },
      { state: "West Sumatra", cities: ["Padang", "Bukittinggi", "Payakumbuh"] },
      { state: "Yogyakarta", cities: ["Yogyakarta", "Sleman"] },
    ],
  },
  {
    country: "Iran",
    states: [
      { state: "Alborz", cities: ["Karaj", "Nazarabad"] },
      { state: "Ardabil", cities: ["Ardabil", "Parsabad", "Meshgin Shahr"] },
      { state: "Bushehr", cities: ["Bushehr", "Borazjan"] },
      { state: "Chaharmahal and Bakhtiari", cities: ["Shahr-e Kord", "Borujen"] },
      { state: "East Azerbaijan", cities: ["Tabriz", "Maragheh", "Marand"] },
      { state: "Fars", cities: ["Shiraz", "Marvdasht", "Jahrom"] },
      { state: "Gilan", cities: ["Rasht", "Bandar-e Anzali", "Lahijan"] },
      { state: "Golestan", cities: ["Gorgan", "Gonbad-e Kavus"] },
      { state: "Hamadan", cities: ["Hamadan", "Malayer"] },
      { state: "Hormozgan", cities: ["Bandar Abbas", "Minab"] },
      { state: "Ilam", cities: ["Ilam", "Dehloran"] },
      { state: "Isfahan", cities: ["Isfahan", "Kashan", "Khomeyni Shahr"] },
      { state: "Kerman", cities: ["Kerman", "Sirjan", "Rafsanjan"] },
      { state: "Kermanshah", cities: ["Kermanshah", "Eslamabad-e Gharb"] },
      { state: "Khuzestan", cities: ["Ahvaz", "Abadan", "Dezful"] },
      { state: "Kohgiluyeh and Boyer-Ahmad", cities: ["Yasuj", "Dogonbadan"] },
      { state: "Kurdistan", cities: ["Sanandaj", "Saqqez", "Marivan"] },
      { state: "Lorestan", cities: ["Khorramabad", "Borujerd"] },
      { state: "Markazi", cities: ["Arak", "Saveh"] },
      { state: "Mazandaran", cities: ["Sari", "Amol", "Babol"] },
      { state: "North Khorasan", cities: ["Bojnurd", "Shirvan"] },
      { state: "Qazvin", cities: ["Qazvin", "Takestan"] },
      { state: "Qom", cities: ["Qom"] },
      { state: "Razavi Khorasan", cities: ["Mashhad", "Sabzevar", "Neyshabur"] },
      { state: "Semnan", cities: ["Semnan", "Damghan"] },
      { state: "Sistan and Baluchestan", cities: ["Zahedan", "Zabol", "Iranshahr"] },
      { state: "South Khorasan", cities: ["Birjand", "Qayen"] },
      { state: "Tehran", cities: ["Tehran", "Eslamshahr", "Varamin"] },
      { state: "West Azerbaijan", cities: ["Urmia", "Khoy", "Mahabad"] },
      { state: "Yazd", cities: ["Yazd", "Ardakan"] },
      { state: "Zanjan", cities: ["Zanjan", "Abhar"] },
    ],
  },
  {
    country: "Iraq",
    states: [
      { state: "Al Anbar", cities: ["Ramadi", "Fallujah", "Hit"] },
      { state: "Babil", cities: ["Hillah", "Al Musayyib"] },
      { state: "Baghdad", cities: ["Baghdad", "Adhamiyah", "Karrada"] },
      { state: "Basra", cities: ["Basra", "Zubair", "Umm Qasr"] },
      { state: "Dhi Qar", cities: ["Nasiriyah", "Suq Al-Shuyukh"] },
      { state: "Al-Qādisiyyah", cities: ["Diwaniyah", "Shamiya"] },
      { state: "Diyala", cities: ["Baqubah", "Muqdadiyah"] },
      { state: "Dohuk", cities: ["Dohuk", "Zakho"] },
      { state: "Erbil", cities: ["Erbil", "Shaqlawa"] },
      { state: "Karbala", cities: ["Karbala", "Hindiyah"] },
      { state: "Kirkuk", cities: ["Kirkuk", "Hawija"] },
      { state: "Maysan", cities: ["Amarah", "Al Majar al Kabir"] },
      { state: "Muthanna", cities: ["Samawah", "Rumaitha"] },
      { state: "Najaf", cities: ["Najaf", "Kufa"] },
      { state: "Nineveh", cities: ["Mosul", "Tal Afar", "Sinjar"] },
      { state: "Saladin", cities: ["Tikrit", "Samarra", "Balad"] },
      { state: "Sulaymaniyah", cities: ["Sulaymaniyah", "Halabja"] },
      { state: "Wasit", cities: ["Kut", "Al-Hayy"] },
    ],
  },
  {
    country: "Ireland",
    states: [
      { state: "Connacht", cities: ["Galway", "Sligo", "Ballina", "Westport"] },
      { state: "Leinster", cities: ["Dublin", "Kilkenny", "Wexford", "Carlow"] },
      { state: "Munster", cities: ["Cork", "Limerick", "Waterford", "Tralee"] },
      { state: "Ulster", cities: ["Letterkenny", "Cavan", "Monaghan"] },
    ],
  },
  {
    country: "Israel",
    states: [
      { state: "Central District", cities: ["Rishon LeZion", "Petah Tikva", "Netanya"] },
      { state: "Haifa District", cities: ["Haifa", "Hadera"] },
      { state: "Jerusalem District", cities: ["Jerusalem", "Beit Shemesh"] },
      { state: "Northern District", cities: ["Nazareth", "Acre", "Safed"] },
      { state: "Southern District", cities: ["Beersheba", "Ashdod", "Ashkelon"] },
      { state: "Tel Aviv District", cities: ["Tel Aviv", "Holon", "Ramat Gan"] },
    ],
  },
  {
    country: "Italy",
    states: [
      { state: "Abruzzo", cities: ["Pescara", "L'Aquila", "Teramo"] },
      { state: "Aosta Valley", cities: ["Aosta"] },
      { state: "Apulia", cities: ["Bari", "Taranto", "Foggia", "Lecce"] },
      { state: "Basilicata", cities: ["Potenza", "Matera"] },
      { state: "Calabria", cities: ["Reggio Calabria", "Catanzaro", "Cosenza"] },
      { state: "Campania", cities: ["Naples", "Salerno", "Torre del Greco"] },
      { state: "Emilia-Romagna", cities: ["Bologna", "Modena", "Parma", "Reggio Emilia"] },
      { state: "Friuli-Venezia Giulia", cities: ["Trieste", "Udine"] },
      { state: "Lazio", cities: ["Rome", "Latina", "Guidonia Montecelio"] },
      { state: "Liguria", cities: ["Genoa", "La Spezia", "Savona"] },
      { state: "Lombardy", cities: ["Milan", "Brescia", "Monza", "Bergamo"] },
      { state: "Marche", cities: ["Ancona", "Pesaro", "Fano"] },
      { state: "Molise", cities: ["Campobasso", "Isernia"] },
      { state: "Piedmont", cities: ["Turin", "Novara", "Alessandria"] },
      { state: "Sardinia", cities: ["Cagliari", "Sassari", "Olbia"] },
      { state: "Sicily", cities: ["Palermo", "Catania", "Messina", "Syracuse"] },
      { state: "Trentino-Alto Adige", cities: ["Trento", "Bolzano"] },
      { state: "Tuscany", cities: ["Florence", "Pisa", "Livorno", "Prato"] },
      { state: "Umbria", cities: ["Perugia", "Terni"] },
      { state: "Veneto", cities: ["Venice", "Verona", "Padua", "Vicenza"] },
    ],
  },
  {
    country: "Jamaica",
    states: [
      { state: "Clarendon", cities: ["May Pen", "Chapelton"] },
      { state: "Hanover", cities: ["Lucea", "Green Island"] },
      { state: "Kingston", cities: ["Kingston", "Port Royal"] },
      { state: "Manchester", cities: ["Mandeville", "Porus"] },
      { state: "Portland", cities: ["Port Antonio", "Buff Bay"] },
      { state: "Saint Andrew", cities: ["Half Way Tree", "Stony Hill"] },
      { state: "Saint Ann", cities: ["Ocho Rios", "Brown's Town"] },
      { state: "Saint Catherine", cities: ["Spanish Town", "Portmore", "Linstead"] },
      { state: "Saint Elizabeth", cities: ["Black River", "Santa Cruz"] },
      { state: "Saint James", cities: ["Montego Bay", "Falmouth"] },
      { state: "Saint Mary", cities: ["Port Maria", "Annotto Bay"] },
      { state: "Saint Thomas", cities: ["Morant Bay", "Yallahs"] },
      { state: "Trelawny", cities: ["Falmouth", "Duncans"] },
      { state: "Westmoreland", cities: ["Savanna-la-Mar", "Negril"] },
    ],
  },
  {
    country: "Japan",
    states: [
      { state: "Aichi", cities: ["Nagoya", "Toyohashi", "Okazaki", "Ichinomiya"] },
      { state: "Akita", cities: ["Akita", "Yokote", "Odate"] },
      { state: "Aomori", cities: ["Aomori", "Hirosaki", "Hachinohe"] },
      { state: "Chiba", cities: ["Chiba", "Funabashi", "Matsudo", "Kashiwa"] },
      { state: "Ehime", cities: ["Matsuyama", "Niihama", "Saijo"] },
      { state: "Fukui", cities: ["Fukui", "Tsuruga", "Obama"] },
      { state: "Fukuoka", cities: ["Fukuoka", "Kitakyushu", "Kurume"] },
      { state: "Fukushima", cities: ["Fukushima", "Koriyama", "Iwaki"] },
      { state: "Gifu", cities: ["Gifu", "Ogaki", "Takayama"] },
      { state: "Gunma", cities: ["Maebashi", "Takasaki", "Ota"] },
      { state: "Hiroshima", cities: ["Hiroshima", "Fukuyama", "Kure"] },
      { state: "Hokkaido", cities: ["Sapporo", "Hakodate", "Asahikawa", "Kushiro"] },
      { state: "Hyogo", cities: ["Kobe", "Himeji", "Amagasaki"] },
      { state: "Ibaraki", cities: ["Mito", "Tsukuba", "Hitachi"] },
      { state: "Ishikawa", cities: ["Kanazawa", "Komatsu", "Kaga"] },
      { state: "Iwate", cities: ["Morioka", "Ichinoseki", "Hanamaki"] },
      { state: "Kagawa", cities: ["Takamatsu", "Marugame"] },
      { state: "Kagoshima", cities: ["Kagoshima", "Kanoya", "Satsumasendai"] },
      { state: "Kanagawa", cities: ["Yokohama", "Kawasaki", "Yokosuka"] },
      { state: "Kochi", cities: ["Kochi", "Nankoku"] },
      { state: "Kumamoto", cities: ["Kumamoto", "Yatsushiro", "Tamana"] },
      { state: "Kyoto", cities: ["Kyoto", "Uji", "Kameoka"] },
      { state: "Mie", cities: ["Tsu", "Yokkaichi", "Suzuka"] },
      { state: "Miyagi", cities: ["Sendai", "Ishinomaki", "Shiogama"] },
      { state: "Miyazaki", cities: ["Miyazaki", "Miyakonojo", "Nobeoka"] },
      { state: "Nagano", cities: ["Nagano", "Matsumoto", "Ueda"] },
      { state: "Nagasaki", cities: ["Nagasaki", "Sasebo", "Isahaya"] },
      { state: "Nara", cities: ["Nara", "Kashihara", "Ikoma"] },
      { state: "Niigata", cities: ["Niigata", "Nagaoka", "Joetsu"] },
      { state: "Oita", cities: ["Oita", "Beppu", "Saiki"] },
      { state: "Okayama", cities: ["Okayama", "Kurashiki", "Tsuyama"] },
      { state: "Okinawa", cities: ["Naha", "Okinawa City", "Uruma"] },
      { state: "Osaka", cities: ["Osaka", "Sakai", "Higashi-Osaka"] },
      { state: "Saga", cities: ["Saga", "Karatsu", "Tosu"] },
      { state: "Saitama", cities: ["Saitama", "Kawaguchi", "Tokorozawa"] },
      { state: "Shiga", cities: ["Otsu", "Kusatsu", "Hikone"] },
      { state: "Shimane", cities: ["Matsue", "Izumo", "Hamada"] },
      { state: "Shizuoka", cities: ["Shizuoka", "Hamamatsu", "Fuji"] },
      { state: "Tochigi", cities: ["Utsunomiya", "Oyama", "Ashikaga"] },
      { state: "Tokushima", cities: ["Tokushima", "Naruto", "Anan"] },
      { state: "Tokyo", cities: ["Tokyo", "Hachioji", "Machida"] },
      { state: "Tottori", cities: ["Tottori", "Yonago", "Kurayoshi"] },
      { state: "Toyama", cities: ["Toyama", "Takaoka", "Imizu"] },
      { state: "Wakayama", cities: ["Wakayama", "Tanabe", "Gobo"] },
      { state: "Yamagata", cities: ["Yamagata", "Tsuruoka", "Sakata"] },
      { state: "Yamaguchi", cities: ["Yamaguchi", "Shimonoseki", "Ube"] },
      { state: "Yamanashi", cities: ["Kofu", "Fujiyoshida", "Tsuru"] },
    ],
  },
  {
    country: "Jordan",
    states: [
      { state: "Ajloun", cities: ["Ajloun", "Anjara"] },
      { state: "Amman", cities: ["Amman", "Al Jizah", "Sahab"] },
      { state: "Aqaba", cities: ["Aqaba", "Tala Bay"] },
      { state: "Balqa", cities: ["Salt", "Deir Alla"] },
      { state: "Irbid", cities: ["Irbid", "Ar Ramtha", "Al Husn"] },
      { state: "Jerash", cities: ["Jerash"] },
      { state: "Karak", cities: ["Al Karak", "Ghawr As-Safi"] },
      { state: "Ma'an", cities: ["Ma'an", "Petra"] },
      { state: "Madaba", cities: ["Madaba", "Dhiban"] },
      { state: "Mafraq", cities: ["Mafraq", "Al Khalidiya"] },
      { state: "Tafilah", cities: ["Tafilah", "Busayra"] },
      { state: "Zarqa", cities: ["Zarqa", "Russeifa"] },
    ],
  },
  {
    country: "Kazakhstan",
    states: [
      { state: "Akmola", cities: ["Kokshetau", "Stepnogorsk"] },
      { state: "Aktobe", cities: ["Aktobe", "Alga"] },
      { state: "Almaty", cities: ["Almaty", "Taldykorgan"] },
      { state: "Atyrau", cities: ["Atyrau", "Kulsary"] },
      { state: "Baikonur", cities: ["Baikonur"] },
      { state: "East Kazakhstan", cities: ["Oskemen", "Semey", "Zyryanovsk"] },
      { state: "Karaganda", cities: ["Karaganda", "Temirtau", "Zhezkazgan"] },
      { state: "Kostanay", cities: ["Kostanay", "Rudny"] },
      { state: "Kyzylorda", cities: ["Kyzylorda", "Baikonur"] },
      { state: "Mangystau", cities: ["Aktau", "Zhanaozen"] },
      { state: "North Kazakhstan", cities: ["Petropavl", "Taiynsha"] },
      { state: "Pavlodar", cities: ["Pavlodar", "Ekibastuz", "Aksu"] },
      { state: "Turkistan", cities: ["Turkistan", "Kentau", "Zhetysay"] },
      { state: "West Kazakhstan", cities: ["Oral", "Aksay"] },
      { state: "Astana", cities: ["Astana"] },
      { state: "Almaty City", cities: ["Almaty"] },
      { state: "Shymkent", cities: ["Shymkent"] },
    ],
  },
  {
    country: "Kenya",
    states: [
      { state: "Baringo", cities: ["Kabarnet", "Eldama Ravine"] },
      { state: "Bomet", cities: ["Bomet", "Sotik"] },
      { state: "Bungoma", cities: ["Bungoma", "Kimilili"] },
      { state: "Busia", cities: ["Busia", "Malaba"] },
      { state: "Elgeyo-Marakwet", cities: ["Iten", "Kapsowar"] },
      { state: "Embu", cities: ["Embu", "Runyenjes"] },
      { state: "Garissa", cities: ["Garissa", "Dadaab"] },
      { state: "Homa Bay", cities: ["Homa Bay", "Mbita"] },
      { state: "Isiolo", cities: ["Isiolo", "Merti"] },
      { state: "Kajiado", cities: ["Kajiado", "Ngong"] },
      { state: "Kakamega", cities: ["Kakamega", "Mumias"] },
      { state: "Kericho", cities: ["Kericho", "Londiani"] },
      { state: "Kiambu", cities: ["Thika", "Ruiru", "Kiambu"] },
      { state: "Kilifi", cities: ["Kilifi", "Malindi", "Mtwapa"] },
      { state: "Kirinyaga", cities: ["Kerugoya", "Sagana"] },
      { state: "Kisii", cities: ["Kisii", "Ogembo"] },
      { state: "Kisumu", cities: ["Kisumu", "Ahero"] },
      { state: "Kitui", cities: ["Kitui", "Mwingi"] },
      { state: "Kwale", cities: ["Kwale", "Ukunda"] },
      { state: "Laikipia", cities: ["Nanyuki", "Nyeri"] },
      { state: "Lamu", cities: ["Lamu", "Mpeketoni"] },
      { state: "Machakos", cities: ["Machakos", "Athi River"] },
      { state: "Makueni", cities: ["Wote", "Makueni"] },
      { state: "Mandera", cities: ["Mandera", "El Wak"] },
      { state: "Marsabit", cities: ["Marsabit", "Moyale"] },
      { state: "Meru", cities: ["Meru", "Maua"] },
      { state: "Migori", cities: ["Migori", "Rongo"] },
      { state: "Mombasa", cities: ["Mombasa", "Likoni"] },
      { state: "Murang'a", cities: ["Murang'a", "Maragua"] },
      { state: "Nairobi", cities: ["Nairobi"] },
      { state: "Nakuru", cities: ["Nakuru", "Naivasha", "Gilgil"] },
      { state: "Nandi", cities: ["Kapsabet", "Nandi Hills"] },
      { state: "Narok", cities: ["Narok", "Kilgoris"] },
      { state: "Nyamira", cities: ["Nyamira", "Keroka"] },
      { state: "Nyandarua", cities: ["Ol Kalou", "Njabini"] },
      { state: "Nyeri", cities: ["Nyeri", "Karatina"] },
      { state: "Samburu", cities: ["Maralal", "Wamba"] },
      { state: "Siaya", cities: ["Siaya", "Bondo"] },
      { state: "Taita-Taveta", cities: ["Voi", "Wundanyi"] },
      { state: "Tana River", cities: ["Hola", "Garsen"] },
      { state: "Tharaka-Nithi", cities: ["Chuka", "Kathwana"] },
      { state: "Trans Nzoia", cities: ["Kitale", "Kimilili"] },
      { state: "Turkana", cities: ["Lodwar", "Kakuma"] },
      { state: "Uasin Gishu", cities: ["Eldoret", "Turbo"] },
      { state: "Vihiga", cities: ["Vihiga", "Mbale"] },
      { state: "Wajir", cities: ["Wajir", "Habaswein"] },
      { state: "West Pokot", cities: ["Kapenguria", "Kacheliba"] },
    ],
  },
  {
    country: "Kiribati",
    states: [
      { state: "Gilbert Islands", cities: ["Tarawa", "Betio"] },
      { state: "Line Islands", cities: ["Kiritimati"] },
      { state: "Phoenix Islands", cities: ["Kanton"] },
    ],
  },
  {
    country: "Korea, North",
    states: [
      { state: "Chagang", cities: ["Kanggye", "Huichon"] },
      { state: "North Hamgyong", cities: ["Chongjin", "Hoeryong", "Kimchaek"] },
      { state: "South Hamgyong", cities: ["Hamhung", "Sinpo"] },
      { state: "North Hwanghae", cities: ["Sariwon", "Kaesong"] },
      { state: "South Hwanghae", cities: ["Haeju", "Pyoksong"] },
      { state: "Kangwon", cities: ["Wonsan", "Munchon"] },
      { state: "North Pyongan", cities: ["Sinuiju", "Kusong"] },
      { state: "South Pyongan", cities: ["Nampo", "Pyongsong", "Anju"] },
      { state: "Ryanggang", cities: ["Hyesan", "Samsu"] },
      { state: "Pyongyang", cities: ["Pyongyang"] },
    ],
  },
  { country: "Korea, South", states: [] },
  { country: "Kosovo", states: [] },
  { country: "Kuwait", states: [] },
  { country: "Kyrgyzstan", states: [] },
  { country: "Laos", states: [] },
  { country: "Latvia", states: [] },
  { country: "Lebanon", states: [] },
  { country: "Lesotho", states: [] },
  { country: "Liberia", states: [] },
  { country: "Libya", states: [] },
  { country: "Liechtenstein", states: [] },
  { country: "Lithuania", states: [] },
  { country: "Luxembourg", states: [] },
  { country: "Madagascar", states: [] },
  { country: "Malawi", states: [] },
  { country: "Malaysia", states: [] },
  { country: "Maldives", states: [] },
  { country: "Mali", states: [] },
  { country: "Malta", states: [] },
  { country: "Marshall Islands", states: [] },
  { country: "Mauritania", states: [] },
  { country: "Mauritius", states: [] },
  { country: "Mexico", states: [] },
  { country: "Micronesia", states: [] },
  { country: "Moldova", states: [] },
  { country: "Monaco", states: [] },
  { country: "Mongolia", states: [] },
  { country: "Montenegro", states: [] },
  { country: "Morocco", states: [] },
  { country: "Mozambique", states: [] },
  { country: "Myanmar (formerly Burma)", states: [] },
  { country: "Namibia", states: [] },
  { country: "Nauru", states: [] },
  { country: "Nepal", states: [] },
  { country: "Netherlands", states: [] },
  { country: "New Zealand", states: [] },
  { country: "Nicaragua", states: [] },
  { country: "Niger", states: [] },
  { country: "Nigeria", states: [] },
  { country: "North Macedonia (formerly Macedonia)", states: [] },
  { country: "Norway", states: [] },
  { country: "Oman", states: [] },
  { country: "Pakistan", states: [] },
  { country: "Palau", states: [] },
  { country: "Palestine", states: [] },
  { country: "Papua New Guinea", states: [] },
  { country: "Paraguay", states: [] },
  // { state: "Peru", cities: ["Lima", "Arequipa", "Trujillo", "Chiclayo"] },
  // { state: "Philippines", cities: ["Quezon City", "Manila", "Davao City", "Cebu City"] },
  // { state: "Poland", cities: ["Warsaw", "Kraków", "Łódź", "Wrocław"] },
  // { state: "Portugal", cities: ["Lisbon", "Porto", "Amadora", "Braga"] },
  // { state: "Qatar", cities: ["Doha", "Al Rayyan", "Umm Salal"] },
  // { state: "Russia", cities: ["Moscow", "Saint Petersburg", "Novosibirsk", "Yekaterinburg"] },
  // { state: "Rwanda", cities: ["Kigali", "Gisenyi", "Ruhengeri", "Butare"] },
  // { state: "Saint Kitts and Nevis", cities: ["Basseterre", "Charlestown", "Dieppe Bay Town"] },
  // { state: "Saint Lucia", cities: ["Castries", "Gros Islet", "Vieux Fort"] },
  // { state: "Saint Vincent and the Grenadines", cities: ["Kingstown", "Georgetown", "Byera Village"] },
  { country: "Samoa", states: [] },
  { country: "San Marino", states: [] },
  { country: "Sao Tome and Principe", states: [] },
  { country: "Saudi Arabia", states: [] },
  { country: "Senegal", states: [] },
  { country: "Serbia", states: [] },
  { country: "Seychelles", states: [] },
  { country: "Sierra Leone", states: [] },
  { country: "Singapore", states: [] },
  { country: "Slovakia", states: [] },
  { country: "Slovenia", states: [] },
  { country: "Solomon Islands", states: [] },
  { country: "Somalia", states: [] },
  { country: "South Africa", states: [] },
  { country: "South Sudan", states: [] },
  { country: "Spain", states: [] },
  { country: "Sri Lanka", states: [] },
  { country: "Sudan", states: [] },
  { country: "Suriname", states: [] },
  { country: "Sweden", states: [] },
  { country: "Switzerland", states: [] },
  { country: "Syria", states: [] },
  { country: "Taiwan", states: [] },
  { country: "Tajikistan", states: [] },
  { country: "Tanzania", states: [] },
  { country: "Thailand", states: [] },
  { country: "Togo", states: [] },
  { country: "Tonga", states: [] },
  { country: "Trinidad and Tobago", states: [] },
  { country: "Tunisia", states: [] },
  { country: "Turkey", states: [] },
  { country: "Turkmenistan", states: [] },
  { country: "Tuvalu", states: [] },
  { country: "Uganda", states: [] },
  { country: "Ukraine", states: [] },
  { country: "United Arab Emirates", states: [] },
  { country: "Uruguay", states: [] },
  { country: "Uzbekistan", states: [] },
  { country: "Vanuatu", states: [] },
  { country: "Vatican City (Holy See)", states: [] },
  { country: "Venezuela", states: [] },
  { country: "Vietnam", states: [] },
  { country: "Yemen", states: [] },
  { country: "Zambia", states: [] },
  { country: "Zimbabwe", states: [] },
];

export default countriesData;